﻿document.URLRacine = document.URL.split('/')[0] + '//' + document.URL.split('/')[2];

window.onerror = function mtraiteErreur(errorMsg, url, lineNumber, a, b, color) { //(msg, url, lineNo, columnNo, error,color)
    return mTraiteMessageJs("erreurjs", errorMsg, url, lineNumber, a, b, color)
}

window.lstStackTraceError = []
window.nbErrorSended = 0
window.nomBaseErreur = ""
window.lastDateQuestionOrangeDisplay = new Date()
window.mTraiteMessageJs = function (command, errorMsg, url, lineNumber, a, b, color, funcEnd) {
    if (errorMsg.startsWith("Script error.") ||
        errorMsg == "jquery.min.js:2 Uncaught TypeError: Cannot read properties of null (reading 'scrollHeight')" ||
        errorMsg.contains("ResizeObserver loop completed with undelivered notifications.") ||
        errorMsg.contains("Uncaught TypeError: Cannot read properties of null (reading 'scrollHeight')") ||
        errorMsg.contains("Uncaught TypeError: Cannot read properties of null (reading 'normalize')") ||
        errorMsg.startsWith("Uncaught IndexSizeError: Failed to execute 'setStart' on 'Range':") ||
        errorMsg.startsWith("Uncaught TypeError: y is not a function")) { //erreur extension
        //c'est une erreur js dont on a pas le détail
        //le détail est dans la console mais impossible à récupérer
        return false;
    } else {
        if (typeof parametre != 'undefined' && (parametre.isLocalhost || parametre.afficherMessageErreur)) {
            if (errorMsg.contains("Uncaught TypeError: Cannot read properties of null (reading 'normalize')") || errorMsg.contains("Uncaught TypeError: Cannot read properties of null (reading 'scrollHeight')" || command == 'messagejs')) {
                if (b != null) console.log(b.stack)
            } else {
                if (typeof notify == 'undefined') { DevExpress.ui.notify(errorMsg + "/" + ((b) ? b.stack : url), "error", 15000) }
                else {
                    if ((color != "yellow" && color != "orange") || ((color == "red" || color == "yellow" || color == "orange") && parametre.isLocalhost)) {
                        if (color != "orange" || (color == "orange" && ((new Date()) - window.lastDateQuestionOrangeDisplay) / 1000 > 2)) {
                            window.lastDateQuestionOrangeDisplay = new Date()
                            notify.mShow({
                                message: "<div style='font-size:10px;line-Height:110%'>" + $('<div/>').text(errorMsg).html() + "<br/>" + $('<div/>').text(((b) ? b.stack : url)).html() + "</div>",
                                titre: ((command == "erreurjs") ? "Erreur js" : "Message Js"),
                                img: "<i class='fas fa-exclamation-triangle' style='font-size:30px'/>",
                                tempoSeconde: 10,
                                backgroundcolorcontent: ((typeof color != 'undefined') ? color : ((command == "erreurjs") ? "red" : "orange")),
                                backgroundcolortitle: ((typeof color != 'undefined') ? color : ((command == "erreurjs") ? "red" : "orange"))
                            });
                        }

                    }
                    if (color == "orange" && b != null) console.log(b.stack)
                }
            }
        }

        if (typeof funcEnd == 'undefined') {
            //on cache les jauges si on a pas de function à la fin de l'erreur
            $("body").find(".dx-ctrljauge").each(function () {
                var jauge = $(this).getInstance()
                jauge.mHide();
            })
        }

        if (typeof $DivGeneral != 'undefined' && $DivGeneral) $DivGeneral.show()
        if (nbErrorSended <= 50 || (nbErrorSended > 50 && b && !lstStackTraceError.contains(b.stack))) {
            var urlHandler = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
            if (command == 'erreurjs' || command == 'erreurjsgrave') nbErrorSended += 1
            if (b && !lstStackTraceError.contains(b.stack)) lstStackTraceError.push(b.stack)
            var dataToBeSent = {
                nom_base: nomBaseErreur,
                command: command,
                errormsg: errorMsg,
                url: url,
                stacktrace: window.location.href + "\n" + ((b) ? b.stack : ""),
                ex_catched: ((color == "orange" || errorMsg.contains("Uncaught TypeError: Cannot read properties of null (reading 'normalize')")) ? "1" : "0")
            };
            mCapturerPageImage(function (imgData) {
                dataToBeSent.img_data_screen = imgData
                if (typeof nbReqAjax != 'undefined') nbReqAjax += 1;
                $.post(urlHandler, dataToBeSent, function (data) { }, 'json')
                    .fail(function (data) { })
                    .always(function (data) {
                        if (typeof nbReqAjax != 'undefined') nbReqAjax -= 1;
                        if (typeof funcEnd != 'undefined') funcEnd()
                    });
            }, true)
        } else {
            if (typeof funcEnd != 'undefined') funcEnd()
        }

        return false;
    }
}

window.mGetStackTrace = function () {
    var err = new Error();
    return err.stack;
}

window.lireCookie = function (nom) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        if (parts[0] === nom) return parts[1];
    }
    return null;
}

String.prototype.contains = function (it) {
    return this.indexOf(it) != -1;
};

if (typeof String.prototype.sansAccent != 'function') {
    String.prototype.sansAccent = function () {
        var accent = [
            /[\300-\306]/g, /[\340-\346]/g, // A, a
            /[\310-\313]/g, /[\350-\353]/g, // E, e
            /[\314-\317]/g, /[\354-\357]/g, // I, i
            /[\322-\330]/g, /[\362-\370]/g, // O, o
            /[\331-\334]/g, /[\371-\374]/g, // U, u
            /[\321]/g, /[\361]/g, // N, n
            /[\307]/g, /[\347]/g, // C, c
        ];
        var noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

        var str = this;
        for (var i = 0; i < accent.length; i++) {
            str = str.replace(accent[i], noaccent[i]);
        }

        return str;
    }
}

if (typeof String.prototype.removeLettreTelephone != 'function') {
    String.prototype.removeLettreTelephone = function () {
        var str = this;
        var result = ""
        for (var i = 0; i < str.length; i++) {
            switch (str[i]) {
                case "1": case "2": case "3": case "4": case "5": case "6": case "7": case "8": case "9": case "0": case "+":
                    result += str[i]
                    break;
            }
        }
        return result
    }
}

// Sauvegarde de l'ancienne fonction console.log
window.originalConsoleLog = console.log;
// Surcharger console.log
console.log = function () {
    // Appel de la fonction originale
    if (typeof parametre == 'undefined' || parametre.isLocalhost || parametre.uti_is_pwd_gestionnaire || parametre.affiche_console) originalConsoleLog.apply(console, arguments);
};
window.consoleLogForce = function () {
    window.originalConsoleLog.apply(console, arguments);
}

if (typeof String.prototype.toDateFromStringDateFr !== 'function') {
    String.prototype.toDateFromStringDateFr = function () {
        const [datePart, timePart = "00:00:00"] = this.split(" ");
        const [day, month, year] = datePart.split("/");
        return new Date(`${year}-${month}-${day}T${timePart}`);
    };
}
if (typeof String.prototype.isDateJJMMAAAAHHMMSS != 'function') {
    String.prototype.isDateJJMMAAAAHHMMSS = function () {
        var format = "fr"
        var thedate, day, month, year;
        var onedate;
        var thetime, hours, minutes, seconds;
        var onetime;

        var mysplit = this.split(' ');

        if (mysplit.length != 2) {
            return false;
        }

        thedate = mysplit[0].split('/');

        if (format == "en") {
            year = parseInt(thedate[0], 10);
            month = parseInt(thedate[1], 10);
            day = parseInt(thedate[2], 10);

            if ((mysplit[0].length != 10) || (thedate.length != 3) ||
                (isNaN(year)) || (isNaN(month)) || (isNaN(day)) ||
                (thedate[0].length < 4) || (thedate[1].length < 2) || (thedate[2].length < 2)) {
                return false;
            }
        }
        else if (format == "fr") {
            day = parseInt(thedate[0], 10);
            month = parseInt(thedate[1], 10);
            year = parseInt(thedate[2], 10);

            if ((mysplit[0].length != 10) || (thedate.length != 3) ||
                (isNaN(year)) || (isNaN(month)) || (isNaN(day)) ||
                (thedate[0].length < 2) || (thedate[1].length < 2) || (thedate[2].length < 4)) {
                return false;
            }
        }
        else {
            return false;
        }

        onedate = new Date(year, month - 1, day);
        year = onedate.getFullYear();

        if ((onedate.getDate() != day) ||
            (onedate.getMonth() != month - 1) ||
            (onedate.getFullYear() != year)) {
            return false;
        }

        thetime = mysplit[1].split(':');
        hours = parseInt(thetime[0], 10);
        minutes = parseInt(thetime[1], 10);
        seconds = parseInt(thetime[2], 10);

        if ((mysplit[1].length != 8) || (thetime.length != 3) ||
            (isNaN(hours)) || (isNaN(minutes)) || (isNaN(seconds)) ||
            (thetime[0].length < 2) || (thetime[1].length < 2) || (thetime[2].length < 2)) {
            return false;
        }

        onetime = new Date(year, month - 1, day, hours, minutes, seconds);

        if ((onetime.getHours() != hours) || (onetime.getMinutes() != minutes) || (onetime.getSeconds() != seconds)) {
            return false;
        }

        return true;
    }
}

if (typeof String.prototype.isAssistant != 'function') {
    String.prototype.isAssistant = function () {
        var result = this.split("<html")[1]
        if (typeof result == 'undefined') {
            return false
        } else {
            result = result.substring(0, result.indexOf(">"))
            return result.contains('assistant2="1"') || result.contains('assistant="1"')
        }
    }
}

if (typeof String.prototype.decoupe != 'function') {
    String.prototype.decoupe = function (nb) {
        if (typeof nb == 'undefined') nb = 30
        var result = "";
        var tabTxt = this.split(" ");
        for (var i = 0; i < tabTxt.length; i++) {
            var newTxt = tabTxt[i];
            if (!newTxt.contains("&#") && newTxt.length > 25 && !newTxt.contains(String.fromCharCode(8203))) {
                if (newTxt.length > 50) {
                    var k = 0;
                    var newVal = ""
                    var nbBcle = 0;
                    while (k < newTxt.length) {
                        newVal += newTxt.substring(k, k + 20) + String.fromCharCode(8203);
                        k += 20
                        nbBcle += 1;
                        if (nbBcle > 200) {
                            newVal = newTxt;
                            break;
                        }
                    }
                    newTxt = newVal;
                }
                else {
                    newTxt = newTxt.substring(0, parseInt(newTxt.length / 2)) + String.fromCharCode(8203) + newTxt.substring(parseInt(newTxt.length / 2))
                }
            }
            if (result.length > 0) result += " "
            result += newTxt
        }
        return result
    }
}
if (typeof String.prototype.reduit != 'function') {
    String.prototype.reduit = function (nb, nbFin) {
        if (typeof nb == 'undefined') nb = 8
        if (typeof nbFin == 'undefined') nbFin = nb
        var moitie = parseInt((nb + nbFin) / 2)
        var value = this.trim()
        if (value.length > nb + nbFin) value = value.substring(0, nb) + "…" + value.substring(value.length - (nbFin + 1))
        return value
    }
}
if (typeof String.prototype.decoupeTel != 'function') {
    String.prototype.decoupeTel = function (b) {
        var value = ""
        this.trim().split('').forEach(function (c, idx) {
            value += c
            if ((idx + 1) % 2 == 0) value += "&nbsp;"
        })
        return value
    }
}

if (typeof String.prototype.isDateJJMMAAAA != 'function') {
    String.prototype.isDateJJMMAAAA = function () {
        // Cette fonction permet de vérifier la validité d'une date au format jj/mm/aa ou jj/mm/aaaa
        // Par Romuald

        if (this == "") // si la variable est vide on retourne faux
            return false;

        e = new RegExp("^[0-9]{1,2}\/[0-9]{1,2}\/([0-9]{2}|[0-9]{4})$");

        if (!e.test(this)) // On teste l'expression régulière pour valider la forme de la date
            return false; // Si pas bon, retourne faux

        // On sépare la date en 3 variables pour vérification, parseInt() converti du texte en entier
        j = parseInt(this.split("/")[0], 10); // jour
        m = parseInt(this.split("/")[1], 10); // mois
        a = parseInt(this.split("/")[2], 10); // année

        // Si l'année n'est composée que de 2 chiffres on complète automatiquement
        if (a < 1000) {
            if (a < 89) a += 2000; // Si a < 89 alors on ajoute 2000 sinon on ajoute 1900
            else a += 1900;
        }

        // Définition du dernier jour de février
        // Année bissextile si annnée divisible par 4 et que ce n'est pas un siècle, ou bien si divisible par 400
        if (a % 4 == 0 && a % 100 != 0 || a % 400 == 0) fev = 29;
        else fev = 28;

        // Nombre de jours pour chaque mois
        nbJours = new Array(31, fev, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);

        // Enfin, retourne vrai si le jour est bien entre 1 et le bon nombre de jours, idem pour les mois, sinon retourn faux
        return (m >= 1 && m <= 12 && j >= 1 && j <= nbJours[m - 1]);
    }
}

if (typeof String.prototype.remplacerTout != 'function') {
    String.prototype.remplacerTout = function (find, replace) {
        var txt = this;
        var txtResult = "";
        if (!$.isArray(find)) find = [find]
        find.forEach(function (strRep) {
            if (txt.contains(strRep)) {
                //debugger;
                var i = 0;
                while (txt.contains(strRep)) {
                    var txt1 = txt.substring(0, txt.indexOf(strRep))
                    var txt2 = txt.substring(txt.indexOf(strRep) + strRep.length)
                    txtResult = txtResult + txt1 + replace
                    txt = txt2;
                    i += 1;
                    if (i > 2000) { debugger; return this; }
                }
                txtResult = txtResult + txt;
            }
            else {
                txtResult = txt;
            }
        })
        return txtResult.toString();


        //var txtResult = this.toString();
        //if (!$.isArray(find)) find = [find]
        //find.forEach(function (strRep) {
        //    if (txtResult.contains(strRep)) {
        //        //debugger;
        //        var i = 0;
        //        while (txtResult.contains(strRep)) {
        //            var txt1 = txt.substring(0, txtResult.indexOf(strRep))
        //            var txt2 = txt.substring(txtResult.indexOf(strRep) + strRep.length)
        //            txtResult = txtResult + txt1 + replace
        //            txt = txt2;
        //            i += 1;
        //            if (i > 10000) { debugger; return this; }
        //        }
        //        txtResult = txtResult + txt;
        //    }
        //})
        //return txtResult.toString();
    }
};

if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (str) {
        return str.length > 0 && this.substring(0, str.length) === str;
    }
};

if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function (str) {
        if (str) {
            return str.length > 0 && this.substring(this.length - str.length, this.length) === str;
        }
        else {
            return false;
        }
    }
};

if (typeof String.prototype.valideEmail != 'function') {
    String.prototype.valideEmail = function () {
        if (!this || this.length == 0) return true;
        var ema = this.trim();
        if (ema.length == 0) return true;
        var re = /^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
        return re.test(ema);
    }
}

if (typeof Array.prototype.contains != 'function') {
    Array.prototype.contains = function (value, property) {
        if (typeof property != 'undefined' && property && property.length > 0) {
            var result = false;
            this.forEach(function (item) {
                if ((typeof item[property] === 'string' || item[property] instanceof String) && item[property].contains(value)) result = true;
            });
            return result;
        }
        else {
            return this.filter(function (o) { return o == value }).length > 0
        }
    }
};

window.arraymove = function (arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
}
if (typeof Array.prototype.move != 'function') {
    Array.prototype.move = function (fromIndex, toIndex) {
        var element = this[fromIndex];
        this.splice(fromIndex, 1);
        this.splice(toIndex, 0, element);
    }
};

if (typeof Array.prototype.filterFirst != 'function') {
    Array.prototype.filterFirst = function (func) {
        var result = null
        for (var i = 0; i < this.length; i++) {
            if (func(this[i])) {
                result = this[i]
                break;
            }
        }
        return ((result == null) ? [] : [result]) //return undefined
    }
};

if (typeof Array.prototype.concatNewValue != 'function') {
    Array.prototype.concatNewValue = function (newTab) {
        var result = this.concat([])
        newTab.forEach(function (item) {
            if (!result.contains(item)) result.push(item)
        })
        return result;
    }
};

if (typeof Array.prototype.containsEgale != 'function') {
    Array.prototype.containsEgale = function (value, property) {
        var result = null;
        this.forEach(function (item) {
            if ((typeof item[property] === 'string' || item[property] instanceof String) && item[property] == value) result = item;
        });
        return result;
    }
};

if (typeof Array.prototype.removeElementWithIdKey != 'function') {
    Array.prototype.removeElementWithIdKey = function (value) {
        var result = null;
        this.forEach(function (item) {
            if ((typeof item[Object.keys(item)[0]] === 'string' || item[Object.keys(item)[0]] instanceof String) && item[Object.keys(item)[0]] == value) result = item;
        });
        if (result) this.splice(this.indexOf(result), 1)
    }
};

if (typeof Array.prototype.toStringPipe != 'function') {
    Array.prototype.toStringPipe = function () {
        var result = "";
        this.forEach(function (item) {
            if (result.length > 0) result += "|"
            result += item;
        });
        return result;
    }
};


if (typeof Array.prototype.clone != 'function') {
    Array.prototype.clone = function () {
        return JSON.clone(this)
    }
};


//retourne le parent d'un objet json (test des tableaux ou des objets)
window.dataGetParent = function (itemDataMaitre, itemData) {
    var result = null;
    if (itemDataMaitre == itemData) {
    } else {
        for (var prop in itemDataMaitre) {
            if (itemDataMaitre[prop] === itemData) { result = itemDataMaitre }
            else if (Array.isArray(itemDataMaitre[prop])) {
                for (var idx in itemDataMaitre[prop]) {
                    if (itemDataMaitre[prop][idx] === itemData) { result = itemDataMaitre[prop] }
                    else { result = dataGetParent(itemDataMaitre[prop][idx], itemData) }
                    if (result != null) break;
                }
            } else if (typeof itemDataMaitre[prop] == "object") {
                result = dataGetParent(itemDataMaitre[prop], itemData)
            }
            if (result != null) break;
        }
    }
    return result
}
window.dataGetNiveau = function (itemDataMaitre, itemData, niveau) {
    if (typeof niveau == 'undefined') niveau = 0
    var data = dataGetParent(itemDataMaitre, itemData)
    if (data == null) {
        return niveau
    } else {
        return dataGetNiveau(itemDataMaitre, data, niveau + 1)
    }
}

window.mClearArrayFromJson = function (obj) {
    if (typeof obj == 'object' && Array.isArray(obj)) {
        if (obj.length == 1 && Object.keys(obj[0]).length == 0) obj = [];
        obj.forEach(function (item) { if (typeof item == 'object') mClearArrayFromJson(item); })
    }
    else {
        for (var prop in obj) {
            if (typeof obj[prop] == 'object' && Array.isArray(obj[prop])) {
                if (obj[prop].length == 1 && Object.keys(obj[prop][0]).length == 0) obj[prop] = [];
                obj[prop].forEach(function (item) {
                    if (typeof item == 'object' && Array.isArray(item)) { mClearArrayFromJson(item); }
                    else { if (typeof item == 'object') mClearArrayFromJson(item); }
                })
            }
            else { if (typeof obj[prop] == 'object') mClearArrayFromJson(obj[prop]); }
        }
    }
}

window.mMigreDateToNet = function (data, idx) {
    if (typeof idx == 'undefined') idx = 0
    //if (idx > 20) debugger;
    for (var prop in data) {
        if (typeof prop != 'undefined') {
            if ($.isArray(data[prop])) { data[prop].forEach(function (item) { mMigreDateToNet(item, idx + 1); }); }
            else {
                if (typeof data[prop] == 'object') {
                    if (data[prop] instanceof Date) { try { data[prop] = data[prop].toFrenchDateTime() } catch (e) { } }
                    else { mMigreDateToNet(data[prop], idx + 1); }
                }
            }
        }
    }
}

window.mMigreDateCodeToNet = function (data) {
    for (var prop in data) {
        if ($.isArray(data[prop])) { data[prop].forEach(function (item) { mMigreDateToNet(item); }); }
        else {
            if (typeof data[prop] == 'object') {
                mMigreDateCodeToNet(data[prop])
            } else {
                if (typeof data[prop] == 'string' && data[prop].isDateCode()) data[prop] = data[prop].toDateFromCode()
            }
        }
    }
}

window.mMigreFormatDateFromJsonCalcul = function (data) {
    var dat = new Date()
    mMigreFormatDateFromJson(data)
    var dd = diffdate(dat, new Date(), "ms")
    if (dd > 20) console.log("calcul date: " + dd + "ms")
}

window.mMigreFormatDateFromJson = function (data) {
    //if (typeof lstIgnoreProp == 'undefined') lstIgnoreProp = []
    //window.parseDtpDates(data)
    //return
    for (var prop in data) {
        if (data[prop] != null) {
            if ($.isArray(data[prop])) {
                //if (data[prop].length > 500) {
                //    //on est a priori sur une table 
                //    var lstNomChampDate = []
                //    for (var i = 0; i < 200; i++) {
                //        for (propLig in data[prop][i]) {
                //            if (!lstNomChampDate.contains(propLig) && typeof data[prop][i][propLig] == "string" &&
                //                (data[prop][i][propLig].startsWith("dtp§}") ||
                //                    (data[prop][i][propLig].split("/").length == 3 && data[prop][i][propLig].split(":").length == 3))) {
                //                lstNomChampDate.push(propLig)
                //            }
                //        }
                //    }
                //    data[prop].forEach(function (item) {
                //        lstNomChampDate.forEach(function (propDate) {
                //            var dattt = item[propDate].substring("dtp§}".length)
                //            if (dattt == "null" || dattt.length == 0) { item[propDate] = null }
                //            else { item[propDate] = new Date(dattt) }
                //        })
                //    })
                //} else {
                data[prop].forEach(function (item) {
                    mMigreFormatDateFromJson(item);
                });
                //}
            } else {
                if (typeof data[prop] == 'object') { mMigreFormatDateFromJson(data[prop]); }
                else {
                    //if (!lstIgnoreProp.contains(prop) && data[prop] &&
                    //if (typeof data[prop] == "string" &&
                    //    (prop == "dcr" || prop == "dmo" || prop == "dateNow" ||
                    //        (typeof data[prop].split != 'undefined' && data[prop].split("/").length == 3 && data[prop].split(":").length == 3))) {
                    if (typeof data[prop] == "string" && (data[prop].startsWith("dtp§}") || (data[prop].split("/").length == 3 && data[prop].split(":").length == 3))) {
                        //if (prop != "dcr" && prop != "dmo") debugger;
                        if (data[prop].startsWith("dtp§}")) {
                            var dattt = data[prop].substring("dtp§}".length)
                            if (dattt == "null" || dattt.length == 0) { data[prop] = null }
                            else { data[prop] = new Date(dattt) }
                        } else {
                            var datt = ""
                            try { datt = data[prop].toDate() } catch (e) { datt = data[prop] }
                            if (datt != "Invalid Date") data[prop] = datt
                        }
                    }
                }
            }
        }
    }
}

window.convertDates = function (obj) {
    if (Array.isArray(obj))
        return obj.map(convertDates);

    if (obj && typeof obj === "object") {
        Object.keys(obj).forEach(key => {
            obj[key] = convertDates(obj[key]);
        });
        return obj;
    }

    if (typeof obj === "string") {

        // YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(obj)) {
            const d = new Date(obj + "T00:00:00");

            if (!isNaN(d.getTime()))
                return d;
        }

        // YYYY-MM-DDTHH:mm:ss...
        if (/^\d{4}-\d{2}-\d{2}T/.test(obj)) {
            const d = new Date(obj);

            if (!isNaN(d.getTime()))
                return d;
        }
    }

    return obj;
}

window.parseDtpDates = function (input, inPlace = false) {
    if (typeof input === "string") {
        if (input.startsWith("dtp§}")) {
            let dateStr = input.substring(5);

            // Nettoyage : enlever les microsecondes (".0000000") pour rester ISO
            dateStr = dateStr.replace(/\.\d+$/, "Z");

            const m = moment(dateStr);
            return m.isValid() ? m : input;
        }
        return input;
    }

    if (Array.isArray(input)) {
        return input.map(item => parseDtpDates(item));
    }

    if (input && typeof input === "object") {
        const result = {};
        for (const key in input) {
            if (Object.prototype.hasOwnProperty.call(input, key)) {
                result[key] = parseDtpDates(input[key]);
            }
        }
        return result;
    }

    return input;
}

if (typeof Date.prototype.getDotNetTicks != 'function') {
    Date.prototype.getDotNetTicks = function () {
        // Reconstituer la date en UTC à partir des composants
        const utcMs = Date.UTC(
            this.getFullYear(),
            this.getMonth(),
            this.getDate(),
            this.getHours(),
            this.getMinutes(),
            this.getSeconds(),
            this.getMilliseconds()
        );

        // Conversion en BigInt
        const msSince1970 = BigInt(utcMs);

        // 1 ms = 10 000 ticks
        const ticksSince1970 = msSince1970 * 10000n;

        // Offset .NET
        const ticksFrom0001To1970 = 621355968000000000n;

        return ticksSince1970 + ticksFrom0001To1970;
    }
}

function normalizeDotNetTicksToMs(tickString) {
    //const t = BigInt(ticks);
    //return (t / 10000n) * 10000n;
    //639053021499900000 = 639053021490000000
    return tickString.slice(0, -7) + '0000000';
}


if (typeof Date.prototype.decompte != 'function') {
    Date.prototype.decompte = function (dat) {
        var nbSeconde = diffdate(this, dat, "s")
        if (nbSeconde < 60) { return nbSeconde + "s" }
        else if (nbSeconde / 60 < 60) {
            var nbMinute = parseInt(nbSeconde / 60)
            var nbSecondeRestante = nbSeconde - nbMinute * 60
            return nbMinute + "m:" + nbSecondeRestante + "s"
        } else if (nbSeconde / 60 / 60 < 24) {
            var nbHeure = parseInt(nbSeconde / 60 / 60)
            var nbSecondeRestante = nbSeconde - nbHeure * 60 * 60
            var nbMinute = parseInt(nbSecondeRestante / 60)
            nbSecondeRestante = nbSecondeRestante - nbMinute * 60
            return nbHeure + "h:" + nbMinute + "m:" + nbSecondeRestante + "s"
        } else {
            var nbJour = parseInt(nbSeconde / 60 / 60 / 24)
            var nbSecondeRestante = nbSeconde - nbJour * 60 * 60 * 24
            var nbHeure = parseInt(nbSecondeRestante / 60 / 60)
            nbSecondeRestante = nbSecondeRestante - nbHeure * 60 * 60
            var nbMinute = parseInt(nbSecondeRestante / 60)
            nbSecondeRestante = nbSecondeRestante - nbMinute * 60
            return nbJour + "j " + nbHeure + "h:" + nbMinute + "m:" + nbSecondeRestante + "s"
        }
    }
};

if (typeof Date.prototype.toFrenchDateTime != 'function') {
    Date.prototype.toFrenchDateTime = function (court) {
        var txt = "";
        if (this.getDate() <= 9) { txt += "0" + this.getDate() } else { txt += this.getDate() }
        txt += "/"
        if (this.getMonth() + 1 <= 9) { txt += "0" + (this.getMonth() + 1) } else { txt += (this.getMonth() + 1) }
        txt += "/" + this.getFullYear();
        if (typeof court == "undefined" || !court) {
            txt += " ";
            if (this.getHours() <= 9) { txt += "0" + (this.getHours()) } else { txt += (this.getHours()) }
            txt += ":";
            if (this.getMinutes() <= 9) { txt += "0" + (this.getMinutes()) } else { txt += (this.getMinutes()) }
            txt += ":";
            if (this.getSeconds() <= 9) { txt += "0" + (this.getSeconds()) } else { txt += (this.getSeconds()) }
        }
        return txt;
    }
};

if (typeof Date.prototype.getQuarter != 'function') {
    Date.prototype.getQuarter = function () {
        switch (this.getMonth()) {
            case 0: case 1: case 2: return 1; break;
            case 3: case 4: case 5: return 2; break;
            case 6: case 7: case 8: return 3; break;
            case 9: case 10: case 11: return 4; break;
        }
    }
};

if (typeof Date.prototype.toMMMAA != 'function') {
    Date.prototype.toMMMAA = function () {
        var txt = "";
        switch (this.getMonth()) {
            case 0: txt += "Jan"; break;
            case 1: txt += "Fèv"; break;
            case 2: txt += "Mar"; break;
            case 3: txt += "Avr"; break;
            case 4: txt += "Mai"; break;
            case 5: txt += "Juin"; break;
            case 6: txt += "Juil"; break;
            case 7: txt += "Aoû"; break;
            case 8: txt += "Sep"; break;
            case 9: txt += "Oct"; break;
            case 10: txt += "Nov"; break;
            case 11: txt += "Déc"; break;
        }
        txt += " " + this.getFullYear().toString().substring(2)
        return txt;
    }
};

if (typeof Date.prototype.to235959 != 'function') {
    Date.prototype.to235959 = function () {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 23, 59, 59);
    }
};

if (typeof Date.prototype.to000000 != 'function') {
    Date.prototype.to000000 = function () {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
    }
};

if (typeof Date.prototype.toDDMMMAA != 'function') {
    Date.prototype.toDDMMMAA = function () {
        var txt = this.getDate() + " ";
        switch (this.getMonth()) {
            case 0: txt += "Jan"; break;
            case 1: txt += "Fév"; break;
            case 2: txt += "Mar"; break;
            case 3: txt += "Avr"; break;
            case 4: txt += "Mai"; break;
            case 5: txt += "Juin"; break;
            case 6: txt += "Juil"; break;
            case 7: txt += "Aoû"; break;
            case 8: txt += "Sep"; break;
            case 9: txt += "Oct"; break;
            case 10: txt += "Nov"; break;
            case 11: txt += "Déc"; break;
        }
        txt += " " + this.getFullYear().toString().substring(2)
        return txt;
    }
};

window.datediffDay = function (first, second) {
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
}

//Format character	Description
//y	A calendar year.
//Q	A quarter number or name.
//Available combinations with example: "Q" - "2", "QQ" - "02", "QQQ" - "Q2" and "QQQQ" - "2nd quarter".
//M	A month number or name.
//Available combinations with example: "M" - "9", "MM" - "09", "MMM" - "Sep", "MMMM" - "September", "MMMMM" - "S".
//d	A month day.
//E	A week day name.
//Available combinations with example: "E", "EE" or "EEE" - "Tue", "EEEE" - "Tuesday", "EEEEE" - "T".
//a	A day period(am or pm).
//h	An hour.From 1 to 12.
//H	An hour.From 0 to 23.
//m	A minute.
//s	A second.
//S	A fractional second.
//''(two single quotes)	Literal text.Text enclosed in two single quotes is shown as- is.
if (typeof Date.prototype.toFormat != 'function') {
    Date.prototype.toFormat = function (format) {
        return DevExpress.localization.formatDate(this, format).replace(".", "")
    }
};

if (typeof Date.prototype.toDDMMMAAAA != 'function') {
    Date.prototype.toDDMMMAAAA = function () {
        var txt = this.getDate() + " ";
        switch (this.getMonth()) {
            case 0: txt += "Jan"; break;
            case 1: txt += "Fév"; break;
            case 2: txt += "Mar"; break;
            case 3: txt += "Avr"; break;
            case 4: txt += "Mai"; break;
            case 5: txt += "Juin"; break;
            case 6: txt += "Juil"; break;
            case 7: txt += "Aoû"; break;
            case 8: txt += "Sep"; break;
            case 9: txt += "Oct"; break;
            case 10: txt += "Nov"; break;
            case 11: txt += "Déc"; break;
        }
        txt += " " + this.getFullYear()
        return txt;
    }
};

if (typeof Date.prototype.toConcatAAAAMMDD != 'function') {
    Date.prototype.toConcatAAAAMMDD = function () {
        var month = (this.getMonth() + 1).toString()
        if (month.length == 1) month = "0" + month
        var dat = this.getDate().toString()
        if (dat.length == 1) dat = "0" + dat
        var txt = this.getFullYear().toString() + month + dat
        return txt;
    }
};

if (typeof Date.prototype.toDDMMM != 'function') {
    Date.prototype.toDDMMM = function () {
        var txt = this.getDate() + " ";
        switch (this.getMonth()) {
            case 0: txt += "Jan"; break;
            case 1: txt += "Fév"; break;
            case 2: txt += "Mar"; break;
            case 3: txt += "Avr"; break;
            case 4: txt += "Mai"; break;
            case 5: txt += "Juin"; break;
            case 6: txt += "Juil"; break;
            case 7: txt += "Aoû"; break;
            case 8: txt += "Sep"; break;
            case 9: txt += "Oct"; break;
            case 10: txt += "Nov"; break;
            case 11: txt += "Déc"; break;
        }
        //txt += " " + this.getFullYear().toString().substring(2)
        return txt;
    }
};

if (typeof Date.prototype.toDDMM != 'function') {
    Date.prototype.toDDMM = function () {
        var month = (this.getMonth() + 1).toString()
        if (month.length == 1) month = "0" + month
        var dat = this.getDate().toString()
        if (dat.length == 1) dat = "0" + dat
        return dat + "/" + month
    }
};

if (typeof Date.prototype.toDD != 'function') {
    Date.prototype.toDD = function () {
        var dat = this.getDate().toString()
        if (dat.length == 1) dat = "0" + dat
        return dat
    }
};

if (typeof Date.prototype.toDDMMAA != 'function') {
    Date.prototype.toDDMMAA = function () {
        var month = (this.getMonth() + 1).toString()
        if (month.length == 1) month = "0" + month
        var dat = this.getDate().toString()
        if (dat.length == 1) dat = "0" + dat
        var year = this.getFullYear().toString().substring(2)
        return dat + "/" + month + "/" + year
    }
};

if (typeof Date.prototype.toDDMMAAHH != 'function') {
    Date.prototype.toDDMMAAHH = function () {
        var month = (this.getMonth() + 1).toString()
        if (month.length == 1) month = "0" + month
        var dat = this.getDate().toString()
        if (dat.length == 1) dat = "0" + dat
        var year = this.getFullYear().toString().substring(2)
        var hour = this.getHours().toString()
        if (hour.length == 1) hour = "0" + hour
        return dat + "/" + month + "/" + year + ":" + hour
    }
};

if (typeof Date.prototype.toDDMMAAAA != 'function') {
    Date.prototype.toDDMMAAAA = function () {
        var month = (this.getMonth() + 1).toString()
        if (month.length == 1) month = "0" + month
        var dat = this.getDate().toString()
        if (dat.length == 1) dat = "0" + dat
        var year = this.getFullYear().toString()
        return dat + "/" + month + "/" + year
    }
};

if (typeof Date.prototype.toHHMM != 'function') {
    Date.prototype.toHHMM = function () {
        var hour = this.getHours().toString()
        if (hour.length == 1) hour = "0" + hour
        var minute = this.getMinutes().toString()
        if (minute.length == 1) minute = "0" + minute
        return hour + ":" + minute
    }
};

if (typeof Date.prototype.toDDMMMMAAAA != 'function') {
    Date.prototype.toDDMMMMAAAA = function () {
        var txt = this.getDate() + " ";
        switch (this.getMonth()) {
            case 0: txt += "janvier"; break;
            case 1: txt += "février"; break;
            case 2: txt += "mars"; break;
            case 3: txt += "avril"; break;
            case 4: txt += "mai"; break;
            case 5: txt += "juin"; break;
            case 6: txt += "juillet"; break;
            case 7: txt += "août"; break;
            case 8: txt += "septembre"; break;
            case 9: txt += "octobre"; break;
            case 10: txt += "novembre"; break;
            case 11: txt += "décembre"; break;
        }
        txt += " " + this.getFullYear().toString()
        return txt;
    }
};

window.dayOfWeekNames = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];
window.dayOfWeekNamesMin = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
window.dayOfWeekNamesLong = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
if (typeof Date.prototype.dayOfWeekName != 'function') {
    Date.prototype.dayOfWeekName = function (long) {
        if (typeof long == 'undefined') long = 0
        switch (long) {
            case 0: return dayOfWeekNames[this.getDay()]; break;
            case 1: return dayOfWeekNamesMin[this.getDay()]; break;
            case 2: return dayOfWeekNamesLong[this.getDay()]; break;
        }
    }
};

window.monthNameCourt = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"]
window.monthNameLong = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
if (typeof Date.prototype.monthName != 'function') {
    Date.prototype.monthName = function (long) {
        if (typeof long == 'undefined') long = 0
        switch (long) {
            case 0: return monthNameCourt[this.getMonth()]; break;
            case 1: return monthNameLong[this.getMonth()]; break;
        }
    }
};


// vérifie si la string contient une date sauvegarder en json dans un varchar
if (typeof String.prototype.isDateCode != 'function') {
    String.prototype.isDateCode = function () {
        if (this.length > 0) {
            if (this.split("-").length == 3) {
                if (this.split("-")[0].length == 4 && this.split("-")[0].isNumeric()) {
                    if (this.split("-")[1].length == 2 && this.split("-")[1].isNumeric()) {
                        var rest = this.split("-")[2]
                        if (rest.split("T").length == 2 && rest.split("T")[0].length == 2 && rest.split("T")[0].isNumeric()) {
                            rest = rest.split("T")[1]
                            if (rest.split(":").length == 3 && rest.split(":")[0].length == 2 && rest.split(":")[0].isNumeric()) {
                                if (rest.split(":")[1].length == 2 && rest.split(":")[1].isNumeric()) {
                                    rest = rest.split(":")[2]
                                    if (rest.split(".").length == 2 && rest.split(".")[0].length == 2 && rest.split(".")[0].isNumeric()) {
                                        if (rest.split(".")[1].length == 4 && rest.split(".")[1].endsWith("Z")) {
                                            return true
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return false;
        }
        else {
            return false
        }
    }
};
if (typeof String.prototype.toDateFromCode != 'function') {
    String.prototype.toDateFromCode = function () {
        var year = this.split("-")[0]
        var month = this.split("-")[1]
        var day = this.split("-")[2].split("T")[0]
        var hour = this.split("T")[1].split(":")[0]
        var minute = this.split("T")[1].split(":")[1]
        var sec = this.split("T")[1].split(":")[2].split(".")[0]
        return new Date(year, month - 1, day, hour, minute, sec);
    }
};

// vérifie si la string contient une date sauvegarder en sql dans un varchar
if (typeof String.prototype.isDateSql != 'function') {
    String.prototype.isDateSql = function () {
        if (this.length > 0) {
            if (this.split(" ").length == 5) {
                if (this.split(" ")[0].length == 3) {
                    if (this.split(" ")[1].length == 2 && this.split(" ")[1].isNumeric()) {
                        if (this.split(" ")[2].length == 4 && this.split(" ")[2].isNumeric()) {
                            var rest = this.split("  ")[1]
                            if (rest.split(":").length == 2 && rest.split(":")[0].isNumeric()) {
                                if (rest.split(":")[1].endsWith('PM') || rest.split(":")[1].endsWith('AM')) {
                                    return true
                                }
                            }
                        }
                    }
                }
            }
            return false;
        }
        else {
            return false
        }
    }
};
if (typeof String.prototype.toDateFromSql != 'function') {
    String.prototype.toDateFromSql = function () {
        var year = this.split(" ")[2]
        var month = this.split(" ")[0]
        if (month.startsWith("janv")) { month = 0 }
        else if (month.startsWith("févr")) { month = 1 }
        else if (month.startsWith("mars")) { month = 2 }
        else if (month.startsWith("avr")) { month = 3 }
        else if (month.startsWith("mai")) { month = 4 }
        else if (month.startsWith("juin")) { month = 5 }
        else if (month.startsWith("juil")) { month = 6 }
        else if (month.startsWith("août")) { month = 7 }
        else if (month.startsWith("sept")) { month = 8 }
        else if (month.startsWith("oct")) { month = 9 }
        else if (month.startsWith("nov")) { month = 10 }
        else if (month.startsWith("déc")) { month = 11 }
        var day = this.split(" ")[1]
        var hour = 0
        var minute = 0
        var sec = 0
        return new Date(year, month - 1, day, hour, minute, sec);
    }
};

if (typeof String.prototype.isNumeric != 'function') {
    String.prototype.isNumeric = function () {
        return $.isNumeric(this);
    }
};

if (typeof String.prototype.isDateFromJsonServeur != 'function') {
    String.prototype.isDateFromJsonServeur = function () {
        if (this.length > 0) {
            try {
                //return new Date()
                var dat = ""
                var time = ""
                dat = this.split(" ")[0]
                if (this.contains(":")) time = this.split(" ")[1]
                var day = dat.split("/")[0];
                var month = parseInt(dat.split("/")[1]) - 1;
                var year = dat.split("/")[2];
                var heure = 0;
                var min = 0;
                var s = 0;
                if (time.length > 0) {
                    var heure = time.split(":")[0];
                    var min = time.split(":")[1];
                    var s = time.split(":")[2];
                }
                var dat = new Date(year, month, day, heure, min, s);
                return true
            }
            catch (e) {
                return false
            }
        }
        else {
            return false
        }
    }
};

if (typeof String.prototype.toDate != 'function') {
    String.prototype.toDate = function () {
        if (this.length > 0) {
            try {
                //return new Date()
                var dat = ""
                var time = ""
                dat = this.split(" ")[0]
                if (this.contains(":")) time = this.split(" ")[1]
                var day = dat.split("/")[0];
                var month = parseInt(dat.split("/")[1]) - 1;
                var year = dat.split("/")[2];
                var heure = 0;
                var min = 0;
                var s = 0;
                if (time.length > 0) {
                    var heure = time.split(":")[0];
                    var min = time.split(":")[1];
                    var s = time.split(":")[2];
                }
                return new Date(year, month, day, heure, min, s);
            }
            catch (e) {
                return "Invalid Date"
            }
        }
        else {
            return new Date();
        }
    }
};

if (typeof String.prototype.toFixed2 != 'function') {
    String.prototype.toFixed2 = function () {
        return parseFloat(parseFloat(this).toFixed(2))
    }
};



if (typeof String.prototype.sizeFile != 'function') {
    String.prototype.sizeFile = function (nbDecimal, inHtml) {
        if (typeof nbDecimal == 'undefined') nbDecimal = 0
        TailleOctet = parseInt(this);
        var result = ""
        var unit = ""
        if (TailleOctet / 1024 < 1) {
            //ko
            result = (TailleOctet / 1024).formatMoney(nbDecimal, ',', ' ');
            unit = "Ko";
        } else if (TailleOctet / 1024 / 1024 < 1) {
            //Mo
            if (TailleOctet / 1024 < 1000) {
                result = (TailleOctet / 1024).formatMoney(nbDecimal, ',', ' ');
                unit = "Ko";
            } else {
                result = (TailleOctet / 1024 / 1024).formatMoney(nbDecimal, ',', ' ');
                unit = "Mo";
            }
        } else if (TailleOctet / 1024 / 1024 / 1024 < 1) {
            if (TailleOctet / 1024 / 1024 < 1000) {
                result = (TailleOctet / 1024 / 1024).formatMoney(nbDecimal, ',', ' ');
                unit = "Mo";
            } else {
                result = (TailleOctet / 1024 / 1024 / 1024).formatMoney(nbDecimal, ',', ' ');
                unit = "Go";
            }
        }
        else {
            result = (TailleOctet / 1024 / 1024 / 1024).formatMoney(nbDecimal, ',', ' ');
            unit = "Go";
        }
        if (nbDecimal >= 2) {
            if (result.toString().contains(",")) {
                if (result.toString().split(",")[0].length >= 4) { result = result.toString().split(",")[0] }
                else if (result.toString().split(",")[0].length >= 3) { result = result.toString().split(",")[0] + "," + result.toString().split(",")[1].substring(0, 1) }
            }
        }
        if (typeof inHtml != 'undefined' && inHtml) result = parseFloat(result.replace(",", ".")).formatDisplay(2)
        return result + unit
    }
};

if (typeof Number.prototype.sizeFile != 'function') {
    Number.prototype.sizeFile = function (nbDecimal, inHtml) {
        return this.toString().sizeFile(nbDecimal, inHtml)
    }
};

if (typeof Number.prototype.toFixed2 != 'function') {
    Number.prototype.toFixed2 = function () {
        return parseFloat(this.toFixed(2))
    }
};

if (typeof Number.prototype.toFixed4 != 'function') {
    Number.prototype.toFixed4 = function () {
        return parseFloat(this.toFixed(4))
    }
};

if (typeof Number.prototype.round != 'function') {
    Number.prototype.round = function (nbDecimal) {
        if (typeof nbDecimal == 'undefined') nbDecimal = 2
        var taux = "1"
        for (var i = 1; i <= nbDecimal; i++) {
            taux += "0"
        }
        return Math.round(this * parseInt(taux)) / parseInt(taux)
    }
};

if (typeof Number.prototype.compact != 'function') {
    Number.prototype.compact = function () {
        return fmtCompact.format(this).replace(/\s/g, '');
    }
}
window.fmtCompact = new Intl.NumberFormat('fr-FR', {
    style: 'currency', currency: 'EUR', notation: 'compact',
    minimumFractionDigits: 0, maximumFractionDigits: 1
});
if (typeof Number.prototype.formatDisplay != 'function') {
    Number.prototype.formatDisplay = function (nbDecimal) {
        if (typeof nbDecimal == "undefined") nbDecimal = 2
        var value = this
        if (nbDecimal > 0) {
            var percent = 1
            for (var i = 1; i <= nbDecimal; i++) { percent = percent * 10 }
            value = Math.round(value * percent) / percent
        }
        var deb = value.toString().split(".")[0]
        var fin = "00"
        if (value.toString().contains(".")) {
            fin = value.toString().split(".")[1]
            if (fin.length == 1) fin += "0"
        }
        if (nbDecimal == 0) fin = ""
        return "<span><span>" + parseInt(deb).formatMoney(0, '', '&nbsp;') + ((nbDecimal == 0) ? "" : ".") + "</span><span style='font-size:70%'>" + fin + "</span></span>"
    }
};

if (typeof Number.prototype.formatMoney != 'function') {
    Number.prototype.formatMoney = function (c, d, t) {
        var n = this,
            c = isNaN(c = Math.abs(c)) ? 2 : c,
            d = d == undefined ? "." : d,
            t = t == undefined ? "," : t,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };
}

if (typeof Date.prototype.toGrpDate != 'function') {
    Date.prototype.toGrpDate = function () {
        var result = null;

        var date0 = new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0)

        var _dtWeekDay = (date0.getDay() + 6) % 7;
        var _dtRefWeekDay = (new Date().getDay() + 6) % 7;

        var _DIF = F = 0;

        var _TS = diffdate(date0, new Date((new Date).getFullYear(), (new Date).getMonth(), (new Date).getDate(), 0, 0, 0), 'd')

        if (this.getFullYear() == 1900 && this.getMonth() == 0 && this.getDate() == 1) {
            //pas de date
            result = -15
        }
        /* same day */
        else if (_TS == 0) { result = 0 + _DIF }
        else {
            /* jour avant */
            if (_TS == 1) { result = -1 + _DIF }
            else {
                /* jour après */
                if (_TS == -1) { result = 1 + _DIF }
                else {
                    /* même semaine */
                    if (_TS > 1 && _TS <= _dtRefWeekDay) { result = _dtWeekDay - 8 + _DIF; }
                    else if (-_TS > 1 && -_TS <= 6 - _dtRefWeekDay) { result = _dtWeekDay + 2 + _DIF; }
                    else {
                        /* previous / next weeks */
                        var _I = 0;
                        while (_I <= 3) {
                            if (_TS > _dtRefWeekDay + _I * 7 && _TS <= _dtRefWeekDay + (_I + 1) * 7) {
                                if ((new Date()).getMonth() + 1 == date0.getMonth() + 1 && (new Date()).getFullYear() == date0.getFullYear()) { result = -(9 + _I) + _DIF; }
                                else { result = -13 + _DIF; }
                                break;
                            }
                            if ((-_TS > 6 - _dtRefWeekDay + _I * 7) && (-_TS <= 6 - _dtRefWeekDay + (_I + 1) * 7)) {
                                if ((new Date()).getMonth() + 1 == date0.getMonth() + 1 && (new Date()).getFullYear() == date0.getFullYear()) { result = (9 + _I) + _DIF; }
                                else { result = 13 + _DIF; }
                                break;
                            }
                            _I = _I + 1;
                        }

                        if (result == null) {
                            var sign = ((_TS < 0) ? -1 : ((_TS > 0) ? 1 : 0))
                            if (Math.abs((date0.getMonth() + 1) - ((new Date()).getMonth() + 1)) <= 1 && (new Date()).getFullYear() == date0.getFullYear()) { result = sign * (-13) + _DIF; }
                            else { result = sign * (-14) + _DIF; }
                        }
                    }
                }
            }
        }

        return {
            id: result,
            libelle: result.getGroupDateLibelle()
        }

    }
};

if (typeof Date.prototype.toDateIlya != 'function') {
    Date.prototype.toDateIlya = function (reduc, DetailMinuteSeconde, dateNow) {
        if (typeof DetailMinuteSeconde == 'undefined' || DetailMinuteSeconde == null) DetailMinuteSeconde = false
        var result = ""
        if (typeof dateNow == 'undefined') dateNow = ((typeof parametre != 'undefined') ? parametre.dateNow : new Date());
        var nbSecondAn = 360 * 24 * 60 * 60
        var nbSecondMois = 30 * 24 * 60 * 60
        var nbSecondJour = 24 * 60 * 60
        var nbSecondHeure = 60 * 60
        var nbSecondMinute = 60

        var nbSecondTotal = (dateNow - this) / 1000
        var nbSecondTotalAbs = Math.abs(nbSecondTotal)

        var nbAnnee = Math.floor(nbSecondTotalAbs / nbSecondAn)
        var nbMois = Math.floor((nbSecondTotalAbs - nbAnnee * nbSecondAn) / nbSecondMois)
        var nbJour = Math.floor((nbSecondTotalAbs - nbMois * nbSecondMois - nbAnnee * nbSecondAn) / nbSecondJour)
        var nbHeure = Math.floor((nbSecondTotalAbs - nbJour * nbSecondJour - nbMois * nbSecondMois - nbAnnee * nbSecondAn) / nbSecondHeure)
        var nbMinute = Math.floor((nbSecondTotalAbs - nbHeure * nbSecondHeure - nbJour * nbSecondJour - nbMois * nbSecondMois - nbAnnee * nbSecondAn) / nbSecondMinute)
        var nbSeconde = Math.floor(nbSecondTotalAbs - nbHeure * nbSecondHeure - nbJour * nbSecondJour - nbMois * nbSecondMois - nbAnnee * nbSecondAn - nbMinute * nbSecondMinute)

        //if (DetailMinuteSeconde) {
        //} else {
        //    if (nbAnnee > 0) {//on ne tient pas compte des heures et minutes //on rajoute 1 mois si plus de 20 jours
        //        if (nbJour > 20) nbMois += 1
        //        nbJour = 0;
        //        nbHeure = 0;
        //        nbMinute = 0;
        //    } else if (nbMois > 0) {
        //        nbHeure = 0;
        //        nbMinute = 0;
        //    } else if (nbJour > 0) {
        //        nbHeure = 0;
        //        nbMinute = 0;
        //    } else if (nbHeure > 0) {
        //        if (nbMinute > 45) nbHeure += 1
        //    }
        //}

        var entete = ""
        var pied = ""
        if (nbSecondTotal < 0) {
            if (typeof reduc != 'undefined' && reduc) { pied = "→"; } else { entete = "dans " }
        } //dans le futur
        else {
            if (typeof reduc != 'undefined' && reduc) { entete = "←" } else { entete = "il y a " }
        } //Dans le passé

        var txt = ""
        if (DetailMinuteSeconde) {
            if (reduc) {
                txt = "" +
                    ((nbAnnee > 0) ? nbAnnee + "A" : "") +
                    ((nbAnnee > 0 && (nbMois > 0 || nbJour > 0 || nbHeure > 0 || nbMinute > 0 || nbSeconde > 0)) ? "" : "") +
                    ((nbMois > 0) ? nbMois + "M" + "" : "") +
                    ((nbMois > 0 && (nbJour > 0 || nbHeure > 0 || nbMinute > 0 || nbSeconde > 0)) ? "" : "") +
                    ((nbJour > 0) ? nbJour + "j" + "" : "") +
                    ((nbJour > 0 && (nbHeure > 0 || nbMinute > 0 || nbSeconde > 0)) ? "" : "") +
                    ((nbHeure > 0) ? nbHeure + "h" + "" : "") +
                    ((nbHeure > 0 && (nbMinute > 0 || nbSeconde > 0)) ? "" : "") +
                    ((nbMinute > 0) ? nbMinute + "m" + "" : "") +
                    ((nbMinute > 0 && (nbSeconde > 0)) ? "" : "") +
                    ((nbSeconde > 0) ? nbSeconde + "s" : "")
            } else {
                txt = "" +
                    ((nbAnnee > 0) ? nbAnnee + " an" + ((nbAnnee > 1) ? "s" : "") + " " : "") +
                    ((nbAnnee > 0 && (nbMois > 0 || nbJour > 0 || nbHeure > 0 || nbMinute > 0 || nbSeconde > 0)) ? "et " : "") +
                    ((nbMois > 0) ? nbMois + " mois" + " " : "") +
                    ((nbMois > 0 && (nbJour > 0 || nbHeure > 0 || nbMinute > 0 || nbSeconde > 0)) ? "et " : "") +
                    ((nbJour > 0) ? nbJour + " jour" + ((nbJour > 1) ? "s" : "") + " " : "") +
                    ((nbJour > 0 && (nbHeure > 0 || nbMinute > 0 || nbSeconde > 0)) ? "et " : "") +
                    ((nbHeure > 0) ? nbHeure + " heure" + ((nbHeure > 1) ? "s" : "") + " " : "") +
                    ((nbHeure > 0 && (nbMinute > 0 || nbSeconde > 0)) ? "et " : "") +
                    ((nbMinute > 0) ? nbMinute + " minute" + ((nbMinute > 1) ? "s" : "") + " " : "") +
                    ((nbMinute > 0 && (nbSeconde > 0)) ? "et " : "") +
                    ((nbSeconde > 0) ? nbSeconde + " seconde" + ((nbSeconde > 1) ? "s" : "") : "")
            }
        } else {
            if (nbAnnee > 0) {
                txt = nbAnnee + " an" + ((nbAnnee > 1) ? "s" : "")
                if (nbMois > 0) txt += ((reduc) ? "" : " et ") + nbMois + " mois"
            } else if (nbMois > 0) {
                txt = nbMois + " mois"
                if (nbJour > 0) txt += ((reduc) ? "" : " et ") + nbJour + " jour" + ((nbJour > 1) ? "s" : "")
            } else if (nbJour > 0) {
                var relativeLib = getRelativeDay(this, dateNow)
                switch (relativeLib) {
                    case "av-hier": case "hier": case "aujourd'hui": case "demain": case "ap-demain":
                        txt = relativeLib
                        if (!reduc) entete = " "
                        break;
                    case "autre":
                        switch (nbJour) {
                            //case 1:
                            //    if (nbHeure > 0 || nbMinute > 0 || nbSeconde > 0) {
                            //        if (nbSecondTotal < 0) {
                            //            var dateRef = new Date(this)
                            //            var dateNowRef = new Date(dateNow)
                            //            dateRef.setDate(dateRef.getDate() + 1);
                            //            if (dateRef.getDate())
                            //                txt = "après-demain"
                            //        } else {
                            //            txt = "avant-hier"
                            //        }
                            //    } else {
                            //        if (nbSecondTotal < 0) {
                            //            txt = "demain"
                            //        } else {
                            //            txt = "hier"
                            //        }
                            //    }
                            //    //entete = ""

                            //    entete = ""
                            //    break;
                            //case 2:
                            //    //entete = ""
                            //    if (nbHeure > 0 || nbMinute > 0 || nbSeconde > 0) {
                            //        txt = nbJour + " jours"
                            //    } else {
                            //        if (nbSecondTotal < 0) {
                            //            txt = "après-demain"
                            //        } else {
                            //            txt = "avant-hier"
                            //        }
                            //    }
                            //    entete = ""
                            //    break;
                            default:
                                txt = nbJour + " jours"
                                break;
                        }
                        break;
                    default:
                        txt = relativeLib
                        break;
                }
            } else if (nbHeure > 0) {
                txt = nbHeure + " heure" + ((nbHeure > 1) ? "s" : "")
            } else if (nbMinute >= 1) {
                txt = nbMinute + " minute" + ((nbMinute > 1) ? "s" : "")
            } else {
                entete = ""
                txt = "Maintenant"
            }
            if (typeof reduc != 'undefined' && reduc) txt = txt.remplacerTout(" heures", "h").remplacerTout(" heure", "h").remplacerTout(" minutes", "mn").remplacerTout(" minute", "mn").remplacerTout(" jours", "j").remplacerTout(" jour", "j").remplacerTout(" mois", "M").remplacerTout(" ans", "A").remplacerTout(" an", "A")
        }

        return entete + txt + pied
    }
};

//Return si hier/avant-hier/demain/aprés-demain/autre
window.getRelativeDay = function (dat, dateNow) {
    const inputDate = new Date(dat);
    if (typeof dateNow == 'undefined') dateNow = new Date();
    dateNow = new Date(dateNow)

    // Normaliser à minuit pour éviter les problèmes d'heure
    inputDate.setHours(0, 0, 0, 0);
    dateNow.setHours(0, 0, 0, 0);

    // Différence en millisecondes
    const diffTime = inputDate.getTime() - dateNow.getTime();

    // Différence en jours
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays === -2) {
        return "av-hier";
    } else if (diffDays === -1) {
        return "hier";
    } else if (diffDays === 0) {
        return "aujourd'hui";
    } else if (diffDays === 1) {
        return "demain";
    } else if (diffDays === 2) {
        return "ap-demain";
    } else {
        return "autre";
    }
}

if (typeof Number.prototype.getGroupDateLibelle != 'function') {
    Number.prototype.getGroupDateLibelle = function () {
        switch (this.toString()) {
            case '-15': case -15: return 'Pas de date'; break;
            case '-14': case -14: return 'Plus vieux'; break;
            case '-13': case -13: return 'Mois dernier'; break;
            case '-12': case -12: return 'Il y a 4 semaines'; break;
            case '-11': case -11: return 'Il y a 3 semaines'; break;
            case '-10': case -10: return 'Il y a 2 semaines'; break;
            case '-9': case -9: return 'Semaine dernière'; break;
            case '-8': case -8: return 'Lundi dernier'; break;
            case '-7': case -7: return 'Mardi dernier'; break;
            case '-6': case -6: return 'Mercredi dernier'; break;
            case '-5': case -5: return 'Jeudi dernier'; break;
            case '-4': case -4: return 'Vendredi dernier'; break;
            case '-3': case -3: return 'Samedi dernier'; break;
            case '-2': case -2: return 'Dimanche dernier'; break;
            case '-1': case -1: return 'Hier'; break;
            case '0': case 0: return "Ce jour"; break;
            case '1': case 1: return 'Demain'; break;
            case '2': case 2: return 'Lundi prochain'; break;
            case '3': case 3: return 'Mardi prochain'; break;
            case '4': case 4: return 'Mercredi prochain'; break;
            case '5': case 5: return 'Jeudi prochain'; break;
            case '6': case 6: return 'Vendredi prochain'; break;
            case '7': case 7: return 'Samedi prochain'; break;
            case '8': case 8: return 'Dimanche prochain'; break;
            case '9': case 9: return 'Semaine prochaine'; break;
            case '10': case 10: return 'Dans 2 semaines'; break;
            case '11': case 11: return 'Dans 3 semaines'; break;
            case '12': case 12: return 'Dans 4 semaines'; break;
            case '13': case 13: return 'Mois prochain'; break;
            case '14': case 14: return 'Plus tard'; break;
            default: return '(Aucune date)'; break;
        }
    }
};

if (typeof String.prototype.getGroupDateLibelle != 'function') {
    String.prototype.getGroupDateLibelle = function () {
        switch (this.toString()) {
            case '-14': case -14: return 'Plus vieux'; break;
            case '-13': case -13: return 'Mois dernier'; break;
            case '-12': case -12: return 'Il y a 4 semaines'; break;
            case '-11': case -11: return 'Il y a 3 semaines'; break;
            case '-10': case -10: return 'Il y a 2 semaines'; break;
            case '-9': case -9: return 'Semaine dernière'; break;
            case '-8': case -8: return 'Lundi'; break;
            case '-7': case -7: return 'Mardi'; break;
            case '-6': case -6: return 'Mercredi'; break;
            case '-5': case -5: return 'Jeudi'; break;
            case '-4': case -4: return 'Vendredi'; break;
            case '-3': case -3: return 'Samedi'; break;
            case '-2': case -2: return 'Dimanche'; break;
            case '-1': case -1: return 'Hier'; break;
            case '0': case 0: return "Ce jour"; break;
            case '1': case 1: return 'Demain'; break;
            case '2': case 2: return 'Lundi prochain'; break;
            case '3': case 3: return 'Mardi prochain'; break;
            case '4': case 4: return 'Mercredi prochain'; break;
            case '5': case 5: return 'Jeudi prochain'; break;
            case '6': case 6: return 'Vendredi prochain'; break;
            case '7': case 7: return 'Samedi prochain'; break;
            case '8': case 8: return 'Dimanche prochain'; break;
            case '9': case 9: return 'Semaine prochaine'; break;
            case '10': case 10: return 'Dans 2 semaines'; break;
            case '11': case 11: return 'Dans 3 semaines'; break;
            case '12': case 12: return 'Dans 4 semaines'; break;
            case '13': case 13: return 'Mois prochain'; break;
            case '14': case 14: return 'Plus tard'; break;
            default: return '(Aucune date)'; break;
        }
    }
};

if (typeof Date.prototype.addSecondes != 'function') {
    Date.prototype.addSecondes = function (Secondes) {
        this.setSeconds(this.getSeconds() + parseInt(Secondes));
        return this;
    };
}

if (typeof Date.prototype.addMinutes != 'function') {
    Date.prototype.addMinutes = function (minutes) {
        this.setMinutes(this.getMinutes() + parseInt(minutes));
        return this;
    };
}

if (typeof Date.prototype.addHours != 'function') {
    Date.prototype.addHours = function (hours) {
        this.setHours(this.getHours() + parseInt(hours));
        return this;
    };
}

if (typeof Date.prototype.addDays != 'function') {
    // On ajoute au prototype de l'objet Date une méthode personnalisée
    Date.prototype.addDays = function (days) {
        // On récupère le jour du mois auquel on ajoute le nombre de jour passé en paramètre
        var day = this.getDate() + parseInt(days);
        // On définit le jour du mois (This représente la date sur laquelle on effectue l'opération)
        this.setDate(day);
        return this;
    }
}

if (typeof Date.prototype.addMonths != 'function') {
    // On ajoute au prototype de l'objet Date une méthode personnalisée
    Date.prototype.addMonths = function (month) {

        var d = this.getDate();
        this.setMonth(this.getMonth() + parseInt(month));
        if (this.getDate() != d) {
            this.setDate(0);
        }
        return this;

        //var newDate = new Date(this.setMonth(this.getMonth() + month));
        //this.setDate(newDate)
        //return this;
    }
}

window.moisEntreDecimal = function (date1, date2) {
    var d1 = new Date(date1);
    var d2 = new Date(date2);

    // Différence brute en millisecondes
    var diffMs = d2 - d1;

    // Durée moyenne d'un mois ≈ 30,44 jours
    var moisMs = 1000 * 60 * 60 * 24 * 30.44;

    return diffMs / moisMs;
}

window.moisJours = function (decimalMois) {
    var mois = Math.floor(decimalMois);          // partie entière = mois
    var fraction = decimalMois - mois;           // partie décimale
    var jours = Math.round(fraction * 30.44);    // approx en jours (moyenne d’un mois)

    return mois + " mois" + ((jours > 0) ? " et " + jours + " jours" : "");
}

window.mCloneObjet = function (obj) {
    obj = JSON.clone(obj)
    function mChangeDateCode(data) {
        for (var prop in data) {
            if ($.isArray(data[prop])) { data[prop].forEach(function (item) { mChangeDateCode(item); }); }
            else {
                if (typeof data[prop] == 'object') { mChangeDateCode(data[prop]); }
                else {
                    if (data[prop] && typeof data[prop].isDateCode != 'undefined') {
                        try { data[prop] = data[prop].toDateFromCode() } catch (e) { }
                    }
                }
            }
        }
    }
    return obj;
}

//si d1<d2, valeur positive
window.diffdate = function (d1, d2, u) {
    var div = 1;
    switch (u) {
        case 'ms':
            div = 1;
            break;
        case 's':
            div = 1000;
            break;
        case 'm':
            div = 1000 * 60;
            break;
        case 'h':
            div = 1000 * 60 * 60;
            break;
        case 'd':
            div = 1000 * 60 * 60 * 24;
            break;
    }

    var Diff = d2.getTime() - d1.getTime();
    return Math.ceil(Diff / div);
}

window.mCursorIsIn = function (element) {
    if (typeof element.offset() != 'undefined' && window.y > element.offset().top && window.y < element.offset().top + element.innerHeight()) {
        if (window.x > element.offset().left && window.x < element.offset().left + element.innerWidth()) {
            return true;
        }
    }
    return false;
}

window.mGetElementFromPoint = function (x, y, doc) {
    if (typeof doc == 'undefined') doc = document
    var element, elements = [];
    var old_visibility = [];
    var idx = 0
    while (true) {
        element = doc.elementFromPoint(x, y);
        if (!element || element === doc.documentElement) {
            break;
        }
        elements.push(element);
        old_visibility.push(element.style.visibility);
        element.style.visibility = 'hidden'; // Temporarily hide the element (without changing the layout)
        idx += 1
        if (idx > 500) break;
    }
    for (var k = 0; k < elements.length; k++) {
        elements[k].style.visibility = old_visibility[k];
    }
    //elements.reverse();
    var result = []
    for (var k = 0; k < elements.length; k++) {
        result.push($(elements[k]))
    }


    return result;
}

// récupération d'un parametre de l'url
window.getParameterUrl = function (p) {
    var url = window.location.search.substring(1);
    var varUrl = url.split('&');
    for (var i = 0; i < varUrl.length; i++) {
        var parameter = varUrl[i].split('=');
        if (parameter[0] == p) {
            return parameter[1];
        }
    }
    return null
}

window.getLstParametreUrl = function () {
    var lst = []
    var url = window.location.search.substring(1);
    var varUrl = url.split('&');
    for (var i = 0; i < varUrl.length; i++) {
        var parameter = varUrl[i].split('=');
        lst.push({
            nom: parameter[0],
            value: parameter[1]
        })
    }
    return lst
}

window.mFileExistOnServeur = function (pathNom) {
    var newPathNom = pathNom;
    if (newPathNom.startsWith("~")) newPathNom = newPathNom.substring(1)
    if (!newPathNom.startsWith("http://") && !newPathNom.startsWith("https://")) newPathNom = document.URLRacine + "/" + newPathNom
    var http = new XMLHttpRequest();
    http.open('HEAD', newPathNom, false);
    http.send();
    return http.status == 200;
}

window.jic = {
    compress: function (source_img_obj, quality, output_format) {

        var mime_type = "image/jpeg";
        if (typeof output_format !== "undefined" && output_format == "png") {
            mime_type = "image/png";
        }

        var cvs = document.createElement('canvas');
        cvs.width = source_img_obj.naturalWidth;
        cvs.height = source_img_obj.naturalHeight;
        var ctx = cvs.getContext("2d").drawImage(source_img_obj, 0, 0);
        var newImageData = cvs.toDataURL(mime_type, quality / 100);
        var result_image_obj = new Image();
        result_image_obj.src = newImageData;
        return result_image_obj;
    },
};

window.mGetMaxZindex = function () {
    var maxZindex = DevExpress.ui.dxOverlay.baseZIndex();
    var lstPopup = $("body").find(".dx-popup-wrapper");
    for (var i = 0; i < lstPopup.length; i++) {
        if (!$(lstPopup[i]).hasClass("dx-diagram-toolbox-popup") && parseInt($(lstPopup[i]).css("z-index")) > maxZindex) {
            maxZindex = parseInt($(lstPopup[i]).css("z-index"))
        }
    }
    var lstPopup = $("body").find(".dx-ctrlpopuprighttranslate");
    for (var i = 0; i < lstPopup.length; i++) {
        if (parseInt($(lstPopup[i]).css("z-index")) > maxZindex) {
            maxZindex = parseInt($(lstPopup[i]).css("z-index"))
        }
    }
    var lstPopup = $("body").find(".dx-ctrlmenuutipopup");
    for (var i = 0; i < lstPopup.length; i++) {
        if (parseInt($(lstPopup[i]).css("z-index")) > maxZindex) {
            maxZindex = parseInt($(lstPopup[i]).css("z-index"))
        }
    }
    if (maxZindex == 0) maxZindex = 20;
    if (maxZindex > 1500) DevExpress.ui.dxOverlay.baseZIndex(maxZindex + 2);
    return maxZindex;
}
//window.mGetMaxZindexElement = function ($ele) {
//    var max = 0;
//    $ele.children().each(function () {
//        var z = $(this).css('z-index');
//        if (z !== 'auto' && !isNaN(z)) {
//            z = parseInt(z, 10);
//            if (z > max) {
//                max = z;
//            }
//        }
//    });
//    return parseInt(max);
//}
window.mGetMaxZindexElement = function ($ele) {
    var max = 0;

    $ele.each(function () {
        var z = $(this).css("z-index");
        if (z !== 'auto' && !isNaN(z)) {
            z = parseInt(z, 10);
            if (z > max) max = z;
        }
    });

    return max;
};

window.mUrlExists = function (url, funcResult) {
    $.ajax({
        type: 'HEAD',
        url: url,
        success: function () { funcResult(true); },
        error: function () { funcResult(false); }
    });
}

if (window.JSON && !window.JSON.clone) {
    JSON.clone = function (data) {
        return JSON.parse(JSON.stringify(data), JSON.dateParser)
    }
}
if (window.JSON && !window.JSON.dateParser) {
    var reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
    var reMsAjax = /^\/Date\((d|-|.*)\)[\/|\\]$/;

    JSON.dateParser = function (key, value) {
        if (typeof value === 'string') {
            var a = reISO.exec(value);
            if (a)
                return new Date(value);
            a = reMsAjax.exec(value);
            if (a) {
                var b = a[1].split(/[-+,.]/);
                return new Date(b[0] ? +b[0] : 0 - +b[1]);
            }
        }
        return value;
    };

}

$(function () {
    try {
        $(".resizable1").resizable(
            {
                autoHide: true,
                handles: 'e',
                resize: function (e, ui) {
                    var parent = ui.element.parent();
                    var remainingSpace = parent.width() - ui.element.outerWidth(),
                        divTwo = ui.element.next(),
                        divTwoWidth = (remainingSpace - (divTwo.outerWidth() - divTwo.width())) / parent.width() * 100 + "%";
                    divTwo.width(divTwoWidth);
                },
                stop: function (e, ui) {
                    var parent = ui.element.parent();
                    ui.element.css(
                        {
                            width: ui.element.width() / parent.width() * 100 + "%",
                        });
                }
            });
    } catch (e) {
        mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
    }
});

window.mDownLoadFile = function (bdd, lstUrl, direct) {
    if ($.isArray(lstUrl)) {
        if (isInAppMobile() && !direct) {
            var lst = []
            lstUrl.forEach(function (u) { lst.push({ url: u }) })
            bdd.mAjaxCall({
                command: "genereurlappmobdownloadfile",
                lst_url: lst
            }, function (data) {
                mDownLoadFile(bdd, data.lsturl, true)
            })
        } else {
            lstUrl.forEach(function (url) {
                const anchor = document.createElement("a");
                if (url.startsWith("~")) url = url.substring(1)
                anchor.href = url;
                anchor.download = (new cFichier(null, url)).mGetNom();
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
            });
        }
    } else {
        if (lstUrl.startsWith("data:image/")) {
            var typeMime = lstUrl.split(":")[1].split(";")[0]
            var typeImg = typeMime.split("/")[1]
            var a = document.createElement("a"); //Create <a>
            a.href = lstUrl; //Image Base64 Goes here
            a.download = "Image." + typeImg; //File name Here
            a.click();
            a.remove();
        } else {
            if (isInAppMobile() && !direct) {
                bdd.mAjaxCall({
                    command: "genereurlappmobdownloadfile",
                    lst_url: [{ url: lstUrl }]
                }, function (data) {
                    mDownLoadFile(bdd, data.lsturl, true)
                })
            } else {
                const anchor = document.createElement("a");
                if (lstUrl.startsWith("~")) lstUrl = lstUrl.substring(1)
                anchor.href = lstUrl;
                anchor.download = (new cFichier(null, lstUrl)).mGetNom();;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
            }
        }
    }
    //if ($.isArray(lstUrl)) {
    //    lstUrl.forEach(function (url) {
    //        var $iFrame = $('<iframe style="width:0;height:0;border:none;display:none;" src="/ext/handlerdownload.ashx?file=' + encodeURI(url) + '"></iframe>').appendTo("body");
    //        window.setTimeout(function () { $iFrame.remove(); }, 5000)
    //    });
    //} else {
    //    if (lstUrl.startsWith("data:image/")) {
    //        var typeMime = lstUrl.split(":")[1].split(";")[0]
    //        var typeImg = typeMime.split("/")[1]
    //        var a = document.createElement("a"); //Create <a>
    //        a.href = lstUrl; //Image Base64 Goes here
    //        a.download = "Image." + typeImg; //File name Here
    //        a.click();
    //        a.remove();
    //    } else {
    //        var $iFrame = $('<iframe style="width:0;height:0;border:none;display:none;" src="/ext/handlerdownload.ashx?file=' + encodeURI(lstUrl) + '"></iframe>').appendTo("body");
    //        window.setTimeout(function () { $iFrame.remove(); }, 5000)
    //    }
    //}
}

window.toDisplayTailleOctet = function (nbOctet) {
    if (nbOctet < 1000) { return nbOctet + " o"; }
    else if (nbOctet < 1000 * 1000) { return (nbOctet / 1024).round().formatDisplay() + " ko"; }
    else if (nbOctet < 1000 * 1000 * 1000) { return (nbOctet / 1024 / 1024).round().formatDisplay() + " Mo"; }
    else if (nbOctet < 1000 * 1000 * 1000 * 1000) { return (nbOctet / 1024 / 1024 / 1024).round().formatDisplay() + " Go"; }
    else { return (nbOctet / 1024 / 1024 / 1024 / 1024).round().formatDisplay() + " To"; }
}


//fonction treeview
//retourne la listes des items en plat a partir d'une source hiérarchique
window.mGetLstItemTreeview = function (item, nomSSItem) {
    if (typeof nomSSItem == 'undefined' || nomSSItem == null) nomSSItem = "items"
    var lst = []
    if (typeof item[nomSSItem] != 'undefined') {
        item[nomSSItem].forEach(function (ssItem) {
            lst.push(ssItem)
            lst = lst.concat(mGetLstItemTreeview(ssItem, nomSSItem))
        })
    }
    return lst
}

//init l'arbre (selected et expanded) à partir d'une autre datasource (hiérarchique)
window.mInitFromSaveTreeview = function (itemData, items, nomSSItem, nomCle) {
    if (typeof nomSSItem == 'undefined' || nomSSItem == null) nomSSItem = "items"
    var trouver = false
    for (var i = 0; i < items.length; i++) {
        var itemDataSave = items[i]
        if (itemData[nomCle] == itemDataSave[nomCle]) {
            if (typeof itemDataSave.selected == 'undefined') { delete itemData.selected }
            else { itemData.selected = itemDataSave.selected }
            if (typeof itemDataSave.expanded == 'undefined') { delete itemData.expanded }
            else { itemData.expanded = itemDataSave.expanded }
            trouver = true
        } else {
            if (typeof itemDataSave[nomSSItem] != 'undefined') trouver = mInitFromSaveTreeview(itemData, itemDataSave[nomSSItem], nomSSItem, nomCle)
        }
        if (trouver) break;
    }
    return trouver;
}

window.mDsIsEgale = function (ds1, ds2, lstChampRemove) {
    if (typeof lstChampRemove == 'undefined') lstChampRemove = []
    var lst1 = []
    if (typeof ds1 != 'undefined') ds1.forEach(function (item) {
        lst1.push(item)
        lst1 = lst1.concat(mGetLstItemTreeview(item))
    })
    var lst2 = []
    if (typeof ds2 != 'undefined') ds2.forEach(function (item) {
        lst2.push(item)
        lst2 = lst2.concat(mGetLstItemTreeview(item))
    })
    var lst1 = JSON.parse(JSON.stringify(lst1))
    var lst2 = JSON.parse(JSON.stringify(lst2))

    lst1.forEach(function (item) {
        delete item.selected; delete item.expanded; delete item.items;
        lstChampRemove.forEach(function (nomChamp) { delete item[nomChamp] })
    })
    lst2.forEach(function (item) {
        delete item.selected; delete item.expanded; delete item.items;
        lstChampRemove.forEach(function (nomChamp) { delete item[nomChamp] })
    })
    return JSON.stringify(lst1) == JSON.stringify(lst2)
}

//function mCountItemsDs(items, nomSSItem) {
//    var nb = items.length
//    if (typeof nomSSItem == 'undefined' || nomSSItem == null) nomSSItem = "items"
//    for (var i = 0; i < items.length; i++) {
//        if (typeof items[i][nomSSItem] != 'undefined') nb += mCountItemsDs(items[i][nomSSItem], nomSSItem)
//    }
//    return nb
//}

window.lstFuncForRemove = []
$.fn.removeDOM = function () {
    $(document).trigger("removeFromDOM", [this]);
    this.remove()
}
$.fn.isChildOf = function ($parent) {
    var parent = this[0]
    while (parent != null) {
        if (parent === $parent[0]) {
            return true
            break;
        }
        parent = $(parent).parent()[0]
    }
    return false
}
//$.fn.emptyAll = function () {

//}

window.colorKeywordToRGB = function (colorKeyword) {

    // CREATE TEMPORARY ELEMENT
    let el = document.createElement('div');

    // APPLY COLOR TO TEMPORARY ELEMENT
    el.style.color = colorKeyword;

    // APPEND TEMPORARY ELEMENT
    document.body.appendChild(el);

    // RESOLVE COLOR AS RGB() VALUE
    let rgbValue = window.getComputedStyle(el).color;

    // REMOVE TEMPORARY ELEMENT
    document.body.removeChild(el);

    return rgbValue;
}


//traduit les évènement de la touch tablette en évènement de souris
window.initTouchHandler = function () {
    document.addEventListener("touchstart", touchHandler, true);
    document.addEventListener("touchmove", touchHandler, true);
    document.addEventListener("touchend", touchHandler, true);
    document.addEventListener("touchcancel", touchHandler, true);
}
window.clickms = 200;
window.lastTouchDown = -1;
window.touchHandler = function (event) {

    var d = new Date();
    var type = event.type
    switch (event.type) {
        case "touchstart": type = "mousedown"; lastTouchDown = d.getTime(); break;
        case "touchmove": type = "mousemove"; lastTouchDown = -1; break;
        case "touchend":
            if (lastTouchDown > -1 && (d.getTime() - lastTouchDown) < clickms) { lastTouchDown = -1; type = "click"; }
            else { type = "mouseup"; }
            break;
        default: return;
    }
    console.log(type)
    var touch = event.changedTouches[0];

    var simulatedEvent = document.createEvent("MouseEvent");
    simulatedEvent.initMouseEvent({
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup",
        click: "click",
        mousemove: "mousemove",
        mousedown: "mousedown",
        mouseup: "mouseup"
    }[type], true, true, window, 1,
        touch.screenX, touch.screenY,
        touch.clientX, touch.clientY, false,
        false, false, false, 0, null);

    touch.target.dispatchEvent(simulatedEvent);
    event.preventDefault();
}

//encodage en base64 d'une string
window.Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a) } return t }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r) } if (a != 64) { t = t + String.fromCharCode(i) } } t = Base64._utf8_decode(t); return t }, _utf8_encode: function (e) { e = e.replace(/\r\n/g, "\n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128) } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128) } } return t }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = c1 = c2 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++ } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2 } else { c2 = e.charCodeAt(n + 1); c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3 } } return t } }

window.fontCheck = new Set([
    // Windows 10
    'Arial', 'Arial Black', 'Bahnschrift', 'Calibri', 'Cambria', 'Cambria Math', 'Candara', 'Comic Sans MS', 'Consolas', 'Constantia', 'Corbel', 'Courier New', 'Ebrima', 'Franklin Gothic Medium', 'Gabriola', 'Gadugi', 'Georgia', 'HoloLens MDL2 Assets', 'Impact', 'Ink Free', 'Javanese Text', 'Leelawadee UI', 'Lucida Console', 'Lucida Sans Unicode', 'Malgun Gothic', 'Marlett', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Sans Serif', 'Microsoft Tai Le', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU-ExtB', 'Mongolian Baiti', 'MS Gothic', 'MV Boli', 'Myanmar Text', 'Nirmala UI', 'Palatino Linotype', 'Segoe MDL2 Assets', 'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Historic', 'Segoe UI Emoji', 'Segoe UI Symbol', 'SimSun', 'Sitka', 'Sylfaen', 'Symbol', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana', 'Webdings', 'Wingdings', 'Yu Gothic',
    // macOS
    'American Typewriter', 'Andale Mono', 'Arial', 'Arial Black', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS', 'Avenir', 'Avenir Next', 'Avenir Next Condensed', 'Baskerville', 'Big Caslon', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bradley Hand', 'Brush Script MT', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charter', 'Cochin', 'Comic Sans MS', 'Copperplate', 'Courier', 'Courier New', 'Didot', 'DIN Alternate', 'DIN Condensed', 'Futura', 'Geneva', 'Georgia', 'Gill Sans', 'Helvetica', 'Helvetica Neue', 'Herculanum', 'Hoefler Text', 'Impact', 'Lucida Grande', 'Luminari', 'Marker Felt', 'Menlo', 'Microsoft Sans Serif', 'Monaco', 'Noteworthy', 'Optima', 'Palatino', 'Papyrus', 'Phosphate', 'Rockwell', 'Savoye LET', 'SignPainter', 'Skia', 'Snell Roundhand', 'Tahoma', 'Times', 'Times New Roman', 'Trattatello', 'Trebuchet MS', 'Verdana', 'Zapfino',
].sort());

window.lstFontBrowser = null
window.mGetLstFontBrowser = function () {
    if (lstFontBrowser == null) {
        lstFontBrowser = []
        const fontAvailable = new Set();
        for (const font of fontCheck.values()) {
            if (document.fonts.check(`12px "${font}"`)) {
                lstFontBrowser.push(font);
            }
        }
    }
    return lstFontBrowser
}

window.getUrlParameter = function (sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? null : decodeURIComponent(sParameterName[1]);
        }
    }
    return null;
};

////surcharge timeOut
//function mSetTimeout(func, tempo) {
//    var nbBoucle = 0
//    var newFunc = function () {
//        nbBoucle += 1
//        if (nbBoucle % 1000) console.log("TimeOut boucle " + nbBoucle + " " + func)
//        func()
//    }
//    return window.setTimeout(newFunc,tempo)
//}


// ANIMATION
window.animateCSS = ($element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = $element[0]; //document.querySelector(element);

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName);

            if (node.getAnimations) {
                node.getAnimations().forEach(anim => anim.cancel());
            }

            node.classList.forEach(cls => {
                if (cls.startsWith('animate__')) {
                    node.classList.remove(cls);
                }
            });

            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });
//window.animateCSS = ($element, animation, prefix = 'animate__') =>
//    new Promise((resolve) => {
//        const animationName = `${prefix}${animation}`;
//        const node = $element[0];

//        // Si une animation précédente est encore "en attente" sur ce nœud,
//        // on la nettoie proprement avant d'en lancer une nouvelle
//        if (node._animateCSSCleanup) {
//            node._animateCSSCleanup();
//        }

//        node.classList.add(`${prefix}animated`, animationName);

//        function handleAnimationEnd(event) {
//            // Ignore les animationend qui ne concernent pas CETTE animation
//            if (event.target !== node || event.animationName !== animationName) return;
//            event.stopPropagation();
//            cleanup();
//            resolve('Animation ended');
//        }

//        function cleanup() {
//            node.removeEventListener('animationend', handleAnimationEnd);
//            node.classList.remove(`${prefix}animated`, animationName);
//            node._animateCSSCleanup = null;
//        }

//        node._animateCSSCleanup = cleanup;
//        node.addEventListener('animationend', handleAnimationEnd);
//    });


window.mConfirmTooltip = function (target, textHtml_funcContent, onConfirm, textButton) {
    var tt2 = $("<div/>").appendTo("body").dxCtrlTooltip({
        target: target,
        contentTemplate: function (contentElement) {
            contentElement.css("padding", "24px");
            if (typeof textHtml_funcContent === 'function') {
                textHtml_funcContent(contentElement)
            } else {
                $("<div style='padding-bottom:15px;'>" + textHtml_funcContent + "</div>").appendTo(contentElement)
            }

            $("<div style='padding-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                text: ((typeof textButton == 'undefined') ? "Confirmer" : textButton),
                width: "100%",
                onClick: function (e) {
                    onConfirm()
                    tt2.hide()
                }
            }).dxCtrlButton("instance")
        }
    }).dxCtrlTooltip("instance");
    tt2.show()
}

window.mConfirmPopup = function (textHtml_funcContent, onConfirm, textBtOk, onCancel, textBtCancel, onHiding, showTitle = true, title = "", width = 400, showClose = true) {
    var opt = {
        shading: true,
        fullScreen: false,
        height: "auto",
        width: width,
        showTitle: showTitle,
        title: title,
        showMaximize: false,
        showCloseButton: showClose,
        contentTemplate: function (contentElement) {
            if (typeof textHtml_funcContent === 'function') {
                var $DivContent = $("<div/>").appendTo(contentElement)
                window.setTimeout(function () { textHtml_funcContent($DivContent, pop) }, 0)
            } else {
                $(textHtml_funcContent).appendTo(contentElement)
            }
            var $Div = $("<div style='text-align:right;'/>").appendTo(contentElement)
            var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%'/>").appendTo($Tr)
            if (typeof onCancel != "undefined" && onCancel != null) {
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                $("<div style='padding-top:10px;display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                    text: ((typeof textBtCancel == 'undefined') ? "Annuler" : textBtCancel),
                    width: "100%",
                    onClick: function (e) {
                        var result = onCancel()
                        if (typeof result == 'undefined' || result) pop.hide()
                    }
                }).dxCtrlButton("instance")
            }
            if (onConfirm) {
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div style='padding-top:10px;display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                    text: ((typeof textBtOk == 'undefined') ? "Confirmer" : textBtOk),
                    width: "100%",
                    onClick: function (e) {
                        var result = onConfirm(pop)
                        if (typeof result == 'undefined' || result) pop.hide()
                    }
                }).dxCtrlButton("instance")
            }
            var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        },
        onHiding: function (e) {
            if (typeof onHiding != 'undefined' && onHiding != null) onHiding(e)
        }
    }
    //if (parametre.isMobile) {
    //    opt.position = {
    //        my: "center top",
    //        at: "center top",
    //        of: window,
    //        offset: "0 50" // ou { x: 0, y: 50 }
    //    }
    //    opt.animation = null
    //    opt.deferRendering = false
    //}
    var pop = $("<div/>").appendTo("body").dxCtrlPopupBase(opt).dxCtrlPopupBase("instance")
    pop.show()
}

window.replaceEncodableChars = function (str) {
    // Fonction pour remplacer les caractères accentués
    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    // Remplace les caractères accentués
    let result = removeAccents(str);

    // Remplace tous les caractères non alphanumériques par un tiret bas
    result = result.replace(/[^\w\s-]/g, "_");

    // Remplace les espaces par des tirets bas
    result = result.replace(/\s+/g, "_");

    // Supprime les tirets bas consécutifs
    result = result.replace(/_+/g, "_");

    // Supprime les tirets bas au début et à la fin
    return result.replace(/^_|_$/g, "");

}

window.formatDateToCustomFormatForRecurrence = function (date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
}

window.parseCustomDateFormatForRecurrence = function (dateString) {
    // Extraire les parties de la chaîne
    if (dateString.contains("-")) {
        //format 2025-11-22T19:00:00Z
        const year = parseInt(dateString.substring(0, 4), 10);
        const month = parseInt(dateString.substring(5, 7), 10) - 1; // Les mois commencent à 0
        const day = parseInt(dateString.substring(8, 10), 10);
        const hours = parseInt(dateString.substring(11, 13), 10);
        const minutes = parseInt(dateString.substring(14, 16), 10);
        const seconds = parseInt(dateString.substring(17, 19), 10);
        // Créer une date en UTC
        return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
    } else {
        //Format 20251122T190000Z
        const year = parseInt(dateString.substring(0, 4), 10);
        const month = parseInt(dateString.substring(4, 6), 10) - 1; // Les mois commencent à 0
        const day = parseInt(dateString.substring(6, 8), 10);
        const hours = parseInt(dateString.substring(9, 11), 10);
        const minutes = parseInt(dateString.substring(11, 13), 10);
        const seconds = parseInt(dateString.substring(13, 15), 10);
        // Créer une date en UTC
        return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
    }


}

//pour éviter l'érreur scrollheight
$.fn.getPageHeight = function () {
    if (!this.length) return 0; // Vérifie que l'élément existe
    return this[0].scrollHeight;
};

window.isPartiallyInViewport = function (elem) {
    var $elem = $(elem);
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var offsetTop = $elem.offset().top;
    var elemHeight = $elem.height();

    return (
        offsetTop < (scrollTop + windowHeight) &&
        (offsetTop + elemHeight) > scrollTop
    );
}

window.observerAvecCallback = function (element, callback) {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            callback(entry.target, entry.isIntersecting); // Appelle la fonction passée
            //if (entry.isIntersecting) {
            //    callback(entry.target); // Appelle la fonction passée
            //    observer.unobserve(entry.target); // Si tu veux que ça se déclenche une seule fois
            //}
        });
    }, {
        threshold: 0.01
    });

    try {
        observer.observe(element);
    } catch (e) {
        debugger
    }

}

//compteur animé
//faire 
//$Div.animateCounter({
//      from: from,
//      to: to,
//      duration: 2000
//    });
//(function ($) {
$.fn.animateCounter = function (options) {
    const settings = $.extend({
        from: 0,
        to: 100,
        duration: 1000,
        step: 1,
        formatter: function (val) {
            return Math.round(val);
        }
    }, options);

    return this.each(function () {
        const $this = $(this);
        const start = settings.from;
        const end = settings.to;
        const range = end - start;
        const direction = range >= 0 ? 1 : -1;
        const startTime = performance.now();

        function animate(currentTime) {
            const elapsed = currentTime - startTime;
            let progress = Math.min(elapsed / settings.duration, 1);
            let value = start + range * progress;

            // Appliquer le step
            if (settings.step > 0) {
                value = start + Math.round((value - start) / settings.step) * settings.step;
            }

            // Empêcher de dépasser
            if ((direction === 1 && value > end) || (direction === -1 && value < end)) {
                value = end;
            }

            $this.text(settings.formatter(value));

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    });
};
//})(jQuery);

window.syntaxHighlightJson = function (json) {
    if (typeof json !== 'string') {
        json = JSON.stringify(json, null, 2); // indenté
    }
    json = json
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    json = json.replace(/("(\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"(?:\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        let cls = 'number';
        if (/^"/.test(match)) {
            cls = /:$/.test(match) ? 'key' : 'string';
        } else if (/true|false/.test(match)) {
            cls = 'boolean';
        } else if (/null/.test(match)) {
            cls = 'null';
        }
        return `<span class="${cls}" style="color:"${((cls == "string") ? "green" : ((cls == "number") ? "darkorange" : ((cls == "boolean") ? "blue" : ((cls == "null") ? "magenta" : ((cls == "key") ? "brown" : "")))))}"">${match}</span>`;
    });

    // Ajoute les sauts de ligne visuellement (à la place des \n)
    return json.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');

}

window.mCaptureScreenImage = function () {
    const dfd = $.Deferred(); // jQuery Deferred = promesse gérable

    navigator.mediaDevices.getDisplayMedia({ video: true }).then(stream => {
        const video = document.createElement('video');
        video.srcObject = stream;
        video.onloadedmetadata = function () {
            video.play();

            setTimeout(function () {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                const imageData = canvas.toDataURL('image/png');
                dfd.resolve(imageData); // renvoyer l'image via la promesse

                // Stopper le stream
                stream.getTracks().forEach(track => track.stop());
            }, 500);
        };
    }).catch(err => {
        dfd.reject(err);
    });

    return dfd.promise();
}

function base64ToBlob(base64, mime = 'image/png') {
    const byteString = atob(base64.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mime });
}

window.mIsValidUrl = function (string) {
    try {
        new URL(string);
        return true;
    } catch (_) {
        return false;
    }
}

window.testUrl = function (url, bddRef, funcFin) {
    bddRef.mAjaxCall({
        command: "testurl",
        url: url
    }, function (data) {
        if (typeof funcFin != 'undefined') funcFin(data.exist == "1");
    }, null, function (data) {
        //plantage de l'appelle // on dit que l'url est ok
        if (typeof funcFin != 'undefined') funcFin(true);
    });
}


window.lastDateShootingLog = null
window.nbShootingLog = 0
window.mCapturerPageImage = function (callBack, forLog) {
    if ((!forLog || (forLog && nbShootingLog < 5 && (lastDateShootingLog == null || ((new Date()) - lastDateShootingLog) > 5000)) && !parametre.isLocalhost)) {
        if (forLog) {
            lastDateShootingLog = new Date()
            nbShootingLog += 1
        }
        const element = $('body')[0];
        try {
            html2canvas(element, {
                logging: false,
                useCORS: true,
                backgroundColor: null,
                removeContainer: true // ← nettoie les DOM clonés automatiquement
            }).then(canvas => {
                // Nettoyage manuel du DOM cloné (si tu utilises background cloning)
                document.querySelectorAll('[data-html2canvas-ignore-clone], .html2canvas-container').forEach(el => el.remove());
                const clones = document.querySelectorAll('[data-html2canvas-ignore-clone]');
                clones.forEach(el => el.remove());

                const imageData = canvas.toDataURL("image/png");
                callBack(imageData)
                console.log("📸 CAPTURE LOG")
            });
        } catch (e) {
            callBack("")
        }
    } else {
        callBack("")
    }
}

//function mCapturerPageImage(callBack) {
//    const html = document.documentElement.outerHTML;

//    const iframe = document.createElement('iframe');
//    iframe.style.position = 'absolute';
//    iframe.style.width = '100vw';
//    iframe.style.height = '100vh';
//    iframe.style.left = '-9999px';
//    iframe.style.top = '-9999px';
//    iframe.style.pointerEvents = 'none';
//    iframe.style.opacity = '0';
//    iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts');
//    iframe.srcdoc = html;
//    document.body.appendChild(iframe);

//    const MAX_WAIT = 5000;
//    const POLL_INTERVAL = 100;

//    let waited = 0;

//    const pollIframeReady = setInterval(async () => {
//        try {
//            const doc = iframe.contentDocument;
//            if (!doc) return;

//            if (doc.readyState === "complete") {
//                clearInterval(pollIframeReady);

//                try {
//                    // Optionnel : délai pour images / fonts
//                    await new Promise(resolve => setTimeout(resolve, 200));

//                    const canvas = await html2canvas(doc.body, {
//                        logging: false,
//                        useCORS: true,
//                        backgroundColor: null,
//                        removeContainer: true
//                    });

//                    const imageData = canvas.toDataURL("image/png");

//                    if (typeof callBack === "function") {
//                        callBack(imageData);
//                    }

//                    canvas.remove?.();
//                } catch (err) {
//                    console.error("❌ Erreur capture canvas :", err);
//                    callBack("");
//                } finally {
//                    iframe.remove();
//                }
//            }

//            waited += POLL_INTERVAL;
//            if (waited >= MAX_WAIT) {
//                console.warn("⚠️ Timeout sur le chargement de l'iframe");
//                clearInterval(pollIframeReady);
//                iframe.remove();
//                callBack("");
//            }
//        } catch (e) {
//            console.error("⚠️ Erreur pendant le polling iframe :", e);
//            clearInterval(pollIframeReady);
//            iframe.remove();
//            callBack("");
//        }
//    }, POLL_INTERVAL);
//}




////CALCUL TAILLE PAGE
//window.mGetTaillePageMo = function () {
//    let totalBytes = 0;

//    // Récupère toutes les ressources chargées
//    const entries = performance.getEntriesByType("resource");

//    // Additionne les tailles transférées
//    entries.forEach(function (entry) {
//        if (entry.transferSize) {
//            totalBytes += entry.transferSize;
//        }
//    });

//    // Ajoute le poids de la page HTML elle-même
//    const navEntry = performance.getEntriesByType("navigation")[0];
//    if (navEntry && navEntry.transferSize) {
//        totalBytes += navEntry.transferSize;
//    }

//    // Affiche le poids total en Ko et Mo
//    const totalKB = (totalBytes / 1024).toFixed(2);
//    const totalMB = (totalBytes / (1024 * 1024)).toFixed(2);

//    console.log("Poids total de la page : " + totalKB + " KB (" + totalMB + " MB)");
//    return totalMB
//}

// SUCHARGE REMOVE
// ------------------
// Sauvegarde de l'original
var originalRemove = $.fn.remove;
// Nouvelle version
$.fn.remove = function () {
    cleanupTinyMCEEtGRidStackInDivs(this);

    if ($(this).getAnimations) {
        $(this).getAnimations().forEach(anim => anim.cancel());
    }

    var allChildren = this.children()
    window.setTimeout(function () {
        allChildren.each(function () {
            // Détacher tous les événements
            $(this).off();
            // Supprimer les données jQuery
            $(this).removeData();
            // Sur les enfants descendants
            $(this).find("*").off().removeData();
        });
    }, 2000)

    //// Détache événements sur l'élément et descendants
    //this.find('*').addBack().each(function () {
    //    $(this).off().removeData();
    //});

    //this.find(".dx-ctrl").each(function () {
    //    $(this).deleteInstance();
    //})
    ////$(this).add($(this).find("*")).each(function () {
    ////    const $el2 = $(this);
    ////    const dataKeys = Object.keys($el2.data());
    ////    dataKeys.forEach(key => {
    ////        if (key.startsWith("dx") && typeof $el2.data(key)?.dispose === "function") {
    ////            $el2.data(key).dispose();
    ////            console.log("🔙 DISPOSE ")
    ////        }
    ////    });
    ////});

    // Supprime les éléments du DOM
    return originalRemove.apply(this, arguments);
};

// SUCHARGE EMPTY
// ------------------
// Sauvegarde la version originale
var originalEmpty = $.fn.empty;
// Redéfinis empty avec nettoyage
$.fn.empty = function () {
    cleanupTinyMCEEtGRidStackInDivs(this);

    if ($(this).getAnimations) {
        $(this).getAnimations().forEach(anim => anim.cancel());
    }

    var allChildren = this.children()
    window.setTimeout(function () {
        allChildren.each(function () {
            // Détacher tous les événements
            $(this).off();
            // Supprimer les données jQuery
            $(this).removeData();
            // Sur les enfants descendants
            $(this).find("*").off().removeData();
        });
    }, 2000)

    //this.find('*').addBack().each(function () {
    //    $(this).off().removeData();
    //});

    //this.find(".dx-ctrl").each(function () {
    //    $(this).deleteInstance();
    //})


    ////$(this).add($(this).find("*")).each(function () {
    ////    const $el2 = $(this);
    ////    const dataKeys = Object.keys($el2.data());
    ////    dataKeys.forEach(key => {
    ////        if (key.startsWith("dx") && typeof $el2.data(key)?.dispose === "function") {
    ////            $el2.data(key).dispose();
    ////            console.log("🔙 DISPOSE ")
    ////        }
    ////    });
    ////});

    return originalEmpty.apply(this, arguments);
};

window.cleanupTinyMCEEtGRidStackInDivs = function ($el) {
    // Trouve tous les éléments avec un ID qui commence par 'divedittinymce'
    var lstEleToDel1 = $el.find('[id^="divedittinymce"]').addBack('[id^="divedittinymce"]')
    var lstEleToDel2 = $el.find('[id^="diveditWidgetHtmlEditor"]').addBack('[id^="diveditWidgetHtmlEditor"]')
    window.setTimeout(function () {
        if (lstEleToDel1.length > 0) {
            lstEleToDel1.each(function () {
                if ($(this).closest("body").length == 0) {
                    const id = this.id;
                    if (id && /^divedittinymce\d+$/.test(id)) {
                        const editor = tinymce.get(id);
                        if (editor) {
                            tinymce.remove(editor);
                            console.log('🧼 TinyMCE inline supprimé pour', id);
                        }
                    }
                }
            });
        }
        if (lstEleToDel2.length > 0) {
            lstEleToDel2.each(function () {
                if ($(this).closest("body").length == 0) {
                    const id = this.id;
                    if (id && /^diveditWidgetHtmlEditor\d+$/.test(id)) {
                        const editor = tinymce.get(id);
                        if (editor) {
                            tinymce.remove(editor);
                            console.log('🧼 TinyMCE inline supprimé pour', id);
                        }
                    }
                }
            });
        }
    }, 20000) //on delete les tinymce aprés 20 secondes le temps de faire la sauvegardeéco

    $el.find(".dx-ctrldashboard").each(function () {
        var gridStack = $(this).getInstance().mGetGrid()
        if (gridStack) gridStack.destroy()
    })
    $el.find('.grid-stack-item').addBack('.grid-stack-item').each(function () {
        $(this).off().removeData();
    });

    disposeAllDxWidgets($el)
    ////$el.add($el.find("*")).each(function () {
    ////    const $el2 = $(this);
    ////    const dataKeys = Object.keys($el2.data());
    ////    dataKeys.forEach(key => {
    ////        if (key.startsWith("dx") && key != "dxToolbar" && typeof $el2.data(key)?.dispose === "function") {
    ////            $el2.data(key).dispose();
    ////            console.log("🔙 DISPOSE " + key)
    ////        }
    ////    });
    ////});
}

window.disposeAllDxWidgets = function ($container) {
    //const disposedElements = new Set();

    //$container.find("*").addBack().each(function () {
    //    const $el = $(this);

    //    // Si cet élément est déjà un enfant d’un widget qu’on a disposé, on skip
    //    for (const parent of $el.parents()) {
    //        if (disposedElements.has(parent)) return;
    //    }

    //    // Vérifie les clés de data
    //    const dataKeys = Object.keys($el.data());
    //    for (const key of dataKeys) {
    //        if (key.startsWith("dx")) {
    //            const instance = $el.data(key);
    //            if (instance && typeof instance.dispose === "function" && key != "dxToolbar") {
    //                instance.dispose();
    //                console.log("🔙 DISPOSE " + key)
    //                disposedElements.add(this); // marquer cet élément comme déjà disposé
    //                break; // ne pas disposer plusieurs fois un même élément
    //            }
    //        }
    //    }
    //});
}

//// SUCHARGE TIMEOUT
//// ------------------
//(function () {
//    var originalSetTimeout = window.setTimeout;
//    var timers = new Map(); // Map élément → timerId

//    function cleanup() {
//        for (const [element, timerId] of timers.entries()) {
//            if (element.closest('body').length === 0) {
//                clearTimeout(timerId);
//                timers.delete(element);
//            }
//        }
//    }

//    // Nettoyage toutes les 500ms
//    setInterval(cleanup, 500);

//    window.setTimeout = function (callback, delay, element) {
//        if (typeof delay == 'undefined') delay = 0
//        if (element && element instanceof jQuery) {
//            var wrappedCallback = function () {
//                timers.delete(element);
//                if (element.closest('body').length === 0) {
//                    // Élément disparu, ne pas exécuter callback
//                    return;
//                }
//                callback();
//            };
//            var timerId = originalSetTimeout(wrappedCallback, delay);
//            timers.set(element, timerId);
//            return timerId;
//        } else {
//            return originalSetTimeout(callback, delay);
//        }
//    };
//})();

window.mGet5sTimeKey = function () {
    const now = new Date();
    const time = Math.floor(now.getTime() / 5000) * 5000;
    return time;
}


//activité utilisateur
window.lastDateActiviteUser = new Date();
window.inactivityThreshold = 5 * 60 * 1000; //5 minutes
window.markActivity = function () {
    window.lastDateActiviteUser = new Date();
}

window.mActiveUser = function () {
    const now = new Date();

    const diff = now - window.lastDateActiviteUser; // OK avec Date
    if (diff > window.inactivityThreshold) {
        $(document).trigger('reactivePage5mn');
    }

    window.lastDateActiviteUser = now;
};

const activityEvents = ['click', 'keydown', 'touchstart'];

activityEvents.forEach(evt => {
    document.addEventListener(evt, markActivity, true);
    document.addEventListener(evt, mActiveUser, true);
});
document.addEventListener('mousemove', markActivity, true);
document.addEventListener('scroll', markActivity, true);
document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
        mActiveUser();
    }
});
//// Focus fenêtre (équivalent jQuery)
//$(window).on("focus", function () {
//    lastDateActiviteUser = new Date()
//});


// Fonction qui teste si une chaîne est une date ISO 8601
window.isIsoDateString = function (str) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[\+\-]\d{2}:\d{2})?$/.test(str) ||
        /^\d{4}-\d{2}-\d{2}$/.test(str);
}

// Fonction récursive de conversion des dates
window.convertDatesObjetJson = function (obj) {
    if (obj === null || obj === undefined) return obj;

    if (Array.isArray(obj)) {
        return obj.map(convertDatesObjetJson);
    } else if (typeof obj === 'object') {
        Object.keys(obj).forEach(function (key) {
            var val = obj[key];
            if (typeof val === 'string' && isIsoDateString(val)) {
                obj[key] = new Date(val);
            } else if (typeof val === 'object') {
                obj[key] = convertDatesObjetJson(val);
            }
        });
        return obj;
    }
    return obj;
}

window.fieldMap = {
    t: "id_table",
    i: "id",
    d: "dmoupdate"
};
window.mMapLstDataGrid = function (lstData) {
    return lstData.map(obj => {
        const result = {};
        // Remplacer les clés via fieldMap
        for (const k in obj) {
            result[fieldMap[k] || k] = obj[k];
        }
        // Ajouter le champ 'cle' si id_table et id sont présents
        result.cle = `${result.id}_${result.id_table}`;

        return result;
    });
}


////surveillance des freeze
//window.lastErrStack = null;
//window.lastFrame = performance.now();

//window.detectFreeze = function () {
//    const now = performance.now();
//    const diff = now - lastFrame;

//    if (diff > 500) {
//        console.warn("⚠️ Freeze détecté (rAF):", Math.round(diff), "ms");
//        console.log("⚠️ stack:" + lastErrStack);
//        //window.mTraiteMessageJs = function (command, errorMsg, url, lineNumber, a, b, color) {
//        mTraiteMessageJs("messagejs", "⚠️ Freeze détecté (rAF):" + Math.round(diff) + "ms", $(location).attr("href"), 0, null, lastErrStack, "yellow")
//    }

//    lastFrame = now;
//    requestAnimationFrame(detectFreeze);
//}

//requestAnimationFrame(detectFreeze);

//window.lastErrStack = null;
//$(document).on('click keydown input', function (event) {
//    // Capturer la stack à ce moment précis
//    lastErrStack = new Error().stack;
//});


////new PerformanceObserver((list) => {
////    list.getEntries().forEach((entry) => {
////        console.warn("⏱ Long task détecté :", entry.duration, "ms");
////        console.trace(); // stack *au moment de la détection* (pas toujours utile)
////    });
////}).observe({ entryTypes: ["longtask"] });

//window.logFreezeIfLong = function (fn) {
//    return function (...args) {
//        if (this.length > 10000) {
//            lastErrStack = new Error();
//            console.warn(`Attention : filter appelé sur un tableau de taille ${this.length}`);
//            console.warn(lastErrStack.stack);
//        }
//        const result = fn.apply(this, args);
//        return result;
//    };
//}

//// Exemple d’utilisation sur un filter :
//const originalFilter = Array.prototype.filter;
//Array.prototype.filter = logFreezeIfLong(originalFilter);

//// Pareil pour forEach
//const originalForEach = Array.prototype.forEach;
//Array.prototype.forEach = logFreezeIfLong(originalForEach);

window.mCopy = function (value, message, e) {
    if (e) e.stopPropagation()
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();
    if (message) mNotify(message, "success", 6000)
}

//gestion perte enter sur dxTxtArea
$(document).on('keydown', '.dx-texteditor-input', function (e) {
    if (e.key === 'Enter' && e.target.tagName === 'TEXTAREA') {
        // si DevExtreme a perdu le listener, on injecte le saut de ligne nous-mêmes
        const ta = e.target;
        const pos = ta.selectionStart;

        // Empêche DevExtreme d'ajouter son propre saut de ligne
        e.preventDefault();
        e.stopPropagation();

        ta.value = ta.value.substring(0, pos) + '\n' + ta.value.substring(pos);
        ta.selectionStart = ta.selectionEnd = pos + 1;
        //e.stopPropagation();
    }
});

// Sauvegarde de la version originale
const _replaceState = window.history.replaceState;
// Surcharge avec correction automatique et try/catch
window.history.replaceState = function (state, title, url) {
    try {
        //// Si l'URL est relative et commence par //, on la normalise
        //if (typeof url === 'string' && url.startsWith('//')) {
        //    url = url.replace(/^\/+/, '/');
        //}

        //// Si aucune URL passée, on reste sur la même
        //if (!url) {
        //    url = window.location.pathname;
        //}

        //// Construction sécurisée de l’URL complète
        //const fullUrl = new URL(url, window.location.origin);

        // Appel de la fonction native
        return _replaceState.call(this, state, title, url) //fullUrl.pathname);
    } catch (e) {
        mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
    }
};


window.filterHierarchy = function (data, nomChamp, nomId, nomIdParent, search) {
    search = search.toLowerCase();

    // Trouver les éléments qui correspondent au nom recherché
    const matched = data.filter(x => x[nomChamp].toLowerCase().includes(search));

    // Créer un Set pour stocker les IDs à garder (évite les doublons)
    const idsToKeep = new Set();

    // Ajouter les lignes trouvées
    matched.forEach(x => idsToKeep.add(x[nomId]));

    // Remonter les parents récursivement
    let added;
    do {
        added = false;
        data.forEach(item => {
            if (idsToKeep.has(item[nomId])) return; // déjà gardé
            const childHasParent = Array.from(idsToKeep).some(id => {
                var idParent = data.find(d => d[nomId] === id)?.[nomIdParent]
                idParent = ((idParent == null) ? idParent : idParent.toString())
                var id = item[nomId]
                id = ((id == null) ? id : id.toString())
                return idParent === id
                //const parentId = data.find(d => d[nomId] === id)?.[nomIdParent];
                //return parentId?.toString() === item[nomId].toString();
            });
            if (childHasParent) {
                idsToKeep.add(item[nomId]);
                added = true;
            }
        });
    } while (added);

    // Retourner uniquement les lignes à garder
    return data.filter(x => idsToKeep.has(x[nomId]));
}

window.generateGuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

window.mGetLstJournees = function (dateDebut, dateFin) {
    const lst = [];

    const d1 = new Date(dateDebut);
    const d2 = new Date(dateFin);

    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    if (d2 < d1) return lst;

    let current = new Date(d1);

    while (current <= d2) {
        lst.push(new Date(current)); // clone obligatoire
        current.setDate(current.getDate() + 1);
    }

    return lst;
};
window.mGetLstDateBetween2Dates = function (startDate, endDate, removeLastDate = true) {
    let result = [];

    let current = new Date(startDate);
    current.setHours(0, 0, 0, 0); // sécurise le point de départ

    let last = new Date(endDate);
    last.setHours(0, 0, 0, 0);

    while (current <= last) {
        let d = new Date(current);
        d.setHours(23, 59, 59, 999); // fin de journée

        result.push(d);

        current.setDate(current.getDate() + 1);
    }

    result.splice(result.length - 1, 1)

    return result;
};
window.mGetNbNuits = function (dateDebut, dateFin) {
    const d1 = new Date(dateDebut);
    const d2 = new Date(dateFin);

    // On sécurise à minuit pour éviter les bugs (heure d'été, etc.)
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    return Math.round((d2 - d1) / 86400000);
};
window.mGetLibNuites = function (dateDeb, datFin) {
    var nbNuit = this.mGetNbNuits()
    var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
    const formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
    if (dateDeb.getFullYear() == datFin.getFullYear()) {
        if (dateDeb.getMonth() == datFin.getMonth()) {
            formatArrive = d => DevExpress.localization.formatDate(d, "dd");
        } else {
            formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM");
        }
    }
    var nbNuit = mGetNbNuits(dateDeb, datFin)
    return "" + dateDeb.dayOfWeekName() + " " + formatArrive(dateDeb) + " → " + datFin.dayOfWeekName() + " " + formatDepart(datFin) + " • " + nbNuit + "<i class='fas fa-moon' title='nuités'></i>"
};

(function () {
    //surcharge le parse pour récupérer des objets date a partir d'une date en string (le stringify met les dates en string)
    const _parse = JSON.parse;

    JSON.parse = function (text, reviver) {
        // Si l'appel provient d'un SDK tiers connu (SumUp, Stripe, etc.), on utilise
        // le parse natif SANS notre reviver de dates -- pour ne pas casser leur code.
        var stack = new Error().stack || "";
        if (/sumup\.com|stripe\.com/i.test(stack)) {
            return _parse(text, reviver);
        }

        // Sinon (nos propres appels JSON.parse partout dans notre code) : comportement inchange.
        var autoReviver = function (key, value) {
            if (typeof value === "string") {
                var isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z)?$/;
                if (isoRegex.test(value)) {
                    return new Date(value);
                }
            }
            return reviver ? reviver(key, value) : value;
        };
        return _parse(text, autoReviver);
    };
})();

window.isValidUrl = function (url) {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
}

window.mInitTrackingClickAndDrag = function ($Ele, funcClick) {
    //gestion du microdrag
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let startTime = 0;

    const DRAG_DELAY = 200; // ms
    const DRAG_THRESHOLD = 5;

    $Ele.on("mousedown", function (e) {
        isDragging = false;
        startX = e.pageX;
        startY = e.pageY;
        startTime = Date.now();
    });

    $Ele.on("mousemove", function (e) {
        const dx = Math.abs(e.pageX - startX);
        const dy = Math.abs(e.pageY - startY);

        const timePassed = Date.now() - startTime;

        if (timePassed > DRAG_DELAY && (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD)) {
            isDragging = true;
        }
    });

    $Ele.on("click", function (e) {
        if (isDragging) {
            e.preventDefault();
            e.stopImmediatePropagation(); // important si autres handlers
            return;
        }
        funcClick()
    });
}

window.isSafariMac = function () {
    const ua = navigator.userAgent;
    return /Macintosh/.test(ua) &&     // macOS
        /Safari/.test(ua) &&        // Safari
        !/Chrome/.test(ua) &&       // pas Chrome
        !/CriOS/.test(ua) &&        // pas Chrome iOS (sécurité)
        !/Firefox/.test(ua);        // pas Firefox
}

const SecretKey = 274653451;
window.msEncodeInteger = function (value) {
    const encoded = value ^ SecretKey;
    return (encoded >>> 0).toString(16).toUpperCase().padStart(8, '0');
}
window.msDecodeInteger = function (encoded) {
    const value = parseInt(encoded, 16);
    return value ^ SecretKey;
}

window.isValidSiret = function (siret) {
    if (siret == '00000000100027') return true //testsiret superpdp
    if (siret == '00000000200027') return true //testsiret superpdp
    if (siret == '000000001') return true //testsiret superpdp
    if (siret == '000000002') return true //testsiret superpdp
    siret = siret.replace(/\s/g, '');

    // Doit contenir exactement 14 chiffres
    if (!/^\d{14}$/.test(siret)) return false;

    let sum = 0;
    let doubleIt = false;

    // parcours de droite à gauche
    for (let i = siret.length - 1; i >= 0; i--) {
        let digit = parseInt(siret.charAt(i), 10);

        if (doubleIt) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }

        sum += digit;
        doubleIt = !doubleIt;
    }

    return (sum % 10) === 0;
}

//pour encoder la querystring d'une url
window.encodeQueryStringSafeUrl = function (str, key) {
    let output = [];
    for (let i = 0; i < str.length; i++) {
        output.push(
            String.fromCharCode(
                str.charCodeAt(i) ^ key.charCodeAt(i % key.length)
            )
        );
    }
    let base64 = btoa(output.join(""));
    // URL SAFE
    return base64
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

window.onFocusInMobile = function (e) {
    if (parametre.isMobile) {
        var $scrollView = e.element.closest(".dx-scrollview");
        if ($scrollView.length) {
            var scrollView = $scrollView.dxScrollView("instance");
            setTimeout(function () {
                scrollView.update();           // recalcule les dimensions scrollables
                // (important : le clavier réduit la zone visible,
                // dxScrollView doit le savoir pour scroller assez loin)
                scrollView.scrollToElement(e.element);
                scrollView.scrollBy(50);
                //mNotify("scroll", "error", 6000)
            }, 1200); // laisse l'animation du clavier se terminer avant de mesurer
        }
    }
}

//window.traiterListe = async function (lst, funcTraitement, funcEnd) {
//    for (const item of lst) {
//        await Promise.resolve(funcTraitement(item));
//    }

//    if (funcEnd) {
//        await Promise.resolve(funcEnd());
//    }
//}

window.traiterListe = function (lst, index, funcTraitement, funcEnd) {
    if (typeof lst[index] == 'undefined') {
        if (funcEnd) funcEnd()
    } else {
        funcTraitement(lst[index], function () {
            traiterListe(lst, index + 1, funcTraitement, funcEnd)
        })
    }
}

//palette couleur sondage
window.PALETTE_DEFAUT = [
    "#2a78d6", // bleu
    "#eb6834", // orange
    "#1baf7a", // aqua
    "#eda100", // jaune
    "#e87ba4", // magenta
    "#008300", // vert
    "#4a3aa7", // violet
    "#e34948"  // rouge
];

//permet d'attendre le rendu complet d'un contrôle
window.awaitForRenderComplete = function ($el) {
    return new Promise(function (resolve) {
        var el = $el[0]
        var stableTimer = null

        var observer = new MutationObserver(function () {
            clearTimeout(stableTimer)
            stableTimer = setTimeout(check, 50)
        })
        observer.observe(el, { childList: true, subtree: true, attributes: true })

        function allImagesLoaded() {
            var imgs = el.querySelectorAll('img')
            return Array.prototype.every.call(imgs, function (img) {
                return img.complete && img.naturalWidth !== 0
            })
        }

        function check() {
            if (allImagesLoaded()) {
                observer.disconnect()
                resolve()
            } else {
                setTimeout(check, 50)
            }
        }

        stableTimer = setTimeout(check, 50)
    })
}

window.toPositiveInt = function (val) {
    if (val === null || val === undefined) return null;
    const s = String(val).trim();
    if (!/^\d+$/.test(s)) return null;      // uniquement des chiffres
    const n = parseInt(s, 10);
    return (n > 0 && Number.isSafeInteger(n)) ? n : null;
}

window.toBase64Url = function (value) {
    return btoa(value)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

window.fromBase64Url = function (value) {
    let b64 = value.replace(/-/g, '+').replace(/_/g, '/');
    // On remet le padding '=' supprimé
    while (b64.length % 4) b64 += '=';
    return atob(b64);
};

//// -----------------------------------------
//// -- Gestion click drop de firefox
//// -----------------------------------------
//// À mettre une seule fois, quelque part au chargement de ton app
//let draggedElement = null;
//document.addEventListener('dragstart', (e) => {
//    draggedElement = e.target;
//});
//document.addEventListener('dragend', () => {
//    // le click parasite de Firefox arrive juste après dragend
//    setTimeout(() => {
//        draggedElement = null;
//    }, 0);
//});
//// Phase de CAPTURE (le "true" en 3e argument) : ça intercepte
//// le click avant qu'il n'atteigne les handlers de clic spécifiques
//// attachés sur chaque élément (qui eux sont en phase bulle par défaut)
//document.addEventListener('click', (e) => {
//    if (draggedElement && (e.target === draggedElement || draggedElement.contains(e.target))) {
//        e.stopPropagation();
//        e.preventDefault();
//        draggedElement = null; // on peut le nettoyer tout de suite ici
//    }
//}, true);

